import React, { useState, useEffect } from 'react';
import { supabase } from '../../../supabaseClient';

// ── Componente Bandera ────────────────────────────────────────────────────────
const BANDERA_KEY = {
  'Mexico':'mexico','South Africa':'sudafrica','Korea Republic':'corea',
  'Czechia':'czechia','Canada':'canada','Bosnia-Herzegovina':'bosnia',
  'USA':'usa','Paraguay':'paraguay','Qatar':'qatar','Switzerland':'suiza',
  'Brazil':'brasil','Morocco':'marruecos','Haiti':'haiti','Scotland':'escocia',
  'Australia':'australia','Turkey':'turquia','Germany':'alemania',
  'Netherlands':'paises-bajos','Japan':'japon','Ecuador':'ecuador',
  'Sweden':'suecia','Spain':'espana','Belgium':'belgica','Egypt':'egipto',
  'Saudi Arabia':'arabia-saudita','Uruguay':'uruguay','Iran':'iran',
  'New Zealand':'nueva-zelanda','France':'francia','Senegal':'senegal',
  'Iraq':'irak','Norway':'noruega','Argentina':'argentina','Algeria':'argelia',
  'Austria':'austria','Portugal':'portugal','England':'inglaterra',
  'Croatia':'croacia','Ghana':'ghana','Panama':'panama','Colombia':'colombia',
  'Serbia':'serbia','Denmark':'dinamarca','Italy':'italia','Chile':'chile',
  'Venezuela':'venezuela','Honduras':'honduras','Nigeria':'nigeria',
  'Cameroon':'camerun','Jamaica':'jamaica','Mali':'mali','Costa Rica':'costa-rica',
  'DR Congo':'congo','Congo DR':'congo',
  'Tunisia':'tunez',
  "Côte d'Ivoire":'costa-marfil',
  'Cabo Verde':'cabo-verde','Curaçao':'curacao','IR Iran':'iran',
  'Jordan':'jordania','Uzbekistan':'uzbekistan',
  // Español
  'México':'mexico','Sudáfrica':'sudafrica','Corea del Sur':'corea',
  'Chequia':'czechia','Canadá':'canada','Bosnia y Herzegovina':'bosnia',
  'Estados Unidos':'usa','Qatar':'qatar','Suiza':'suiza',
  'Brasil':'brasil','Marruecos':'marruecos','Haití':'haiti','Escocia':'escocia',
  'Australia':'australia','Turquía':'turquia','Alemania':'alemania',
  'Países Bajos':'paises-bajos','Japón':'japon','Ecuador':'ecuador',
  'Suecia':'suecia','España':'espana','Bélgica':'belgica','Egipto':'egipto',
  'Arabia Saudita':'arabia-saudita','Uruguay':'uruguay','Irán':'iran',
  'Nueva Zelanda':'nueva-zelanda','Francia':'francia','Senegal':'senegal',
  'Iraq':'irak','Noruega':'noruega','Argentina':'argentina','Argelia':'argelia',
  'Austria':'austria','Portugal':'portugal','Inglaterra':'inglaterra',
  'Croacia':'croacia','Ghana':'ghana','Panamá':'panama','Colombia':'colombia',
  'DR Congo':'congo','Túnez':'tunez','Costa de Marfil':'costa-marfil',
  'Cabo Verde':'cabo-verde','Curazao':'curacao','Jordania':'jordania',
  'Uzbekistán':'uzbekistan','Paraguay':'paraguay',
};
const EMOJIS = {
  'Mexico':'🇲🇽','South Africa':'🇿🇦','Korea Republic':'🇰🇷','Czechia':'🇨🇿',
  'Canada':'🇨🇦','Bosnia-Herzegovina':'🇧🇦','USA':'🇺🇸','Paraguay':'🇵🇾',
  'Qatar':'🇶🇦','Switzerland':'🇨🇭','Brazil':'🇧🇷','Morocco':'🇲🇦',
  'Haiti':'🇭🇹','Scotland':'🏴󠁧󠁢󠁳󠁣󠁴󠁿','Australia':'🇦🇺','Turkey':'🇹🇷',
  'Germany':'🇩🇪','Netherlands':'🇳🇱','Japan':'🇯🇵','Ecuador':'🇪🇨',
  'Sweden':'🇸🇪','Spain':'🇪🇸','Belgium':'🇧🇪','Egypt':'🇪🇬',
  'Saudi Arabia':'🇸🇦','Uruguay':'🇺🇾','Iran':'🇮🇷','New Zealand':'🇳🇿',
  'France':'🇫🇷','Senegal':'🇸🇳','Iraq':'🇮🇶','Norway':'🇳🇴',
  'Argentina':'🇦🇷','Algeria':'🇩🇿','Austria':'🇦🇹','Portugal':'🇵🇹',
  'England':'🏴󠁧󠁢󠁥󠁮󠁧󠁿','Croatia':'🇭🇷','Ghana':'🇬🇭','Panama':'🇵🇦',
  'Colombia':'🇨🇴','Serbia':'🇷🇸','Denmark':'🇩🇰','Italy':'🇮🇹',
  'Chile':'🇨🇱','Venezuela':'🇻🇪','Honduras':'🇭🇳','Nigeria':'🇳🇬',
  'Cameroon':'🇨🇲','Jamaica':'🇯🇲','Mali':'🇲🇱','Costa Rica':'🇨🇷',
  'DR Congo':'🇨🇩','Congo DR':'🇨🇩',
  'Tunisia':'🇹🇳',
  "Côte d'Ivoire":'🇨🇮',
  'Cabo Verde':'🇨🇻','Curaçao':'🇨🇼','IR Iran':'🇮🇷',
  'Jordan':'🇯🇴','Uzbekistan':'🇺🇿',
  // Español
  'México':'🇲🇽','Sudáfrica':'🇿🇦','Corea del Sur':'🇰🇷','Chequia':'🇨🇿',
  'Canadá':'🇨🇦','Bosnia y Herzegovina':'🇧🇦','Estados Unidos':'🇺🇸','Paraguay':'🇵🇾',
  'Qatar':'🇶🇦','Suiza':'🇨🇭','Brasil':'🇧🇷','Marruecos':'🇲🇦',
  'Haití':'🇭🇹','Escocia':'🏴󠁧󠁢󠁳󠁣󠁴󠁿','Australia':'🇦🇺','Turquía':'🇹🇷',
  'Alemania':'🇩🇪','Países Bajos':'🇳🇱','Japón':'🇯🇵','Ecuador':'🇪🇨',
  'Suecia':'🇸🇪','España':'🇪🇸','Bélgica':'🇧🇪','Egipto':'🇪🇬',
  'Arabia Saudita':'🇸🇦','Uruguay':'🇺🇾','Irán':'🇮🇷','Nueva Zelanda':'🇳🇿',
  'Francia':'🇫🇷','Senegal':'🇸🇳','Iraq':'🇮🇶','Noruega':'🇳🇴',
  'Argentina':'🇦🇷','Argelia':'🇩🇿','Austria':'🇦🇹','Portugal':'🇵🇹',
  'Inglaterra':'🏴󠁧󠁢󠁥󠁮󠁧󠁿','Croacia':'🇭🇷','Ghana':'🇬🇭','Panamá':'🇵🇦',
  'Colombia':'🇨🇴','DR Congo':'🇨🇩','Túnez':'🇹🇳','Costa de Marfil':'🇨🇮',
  'Cabo Verde':'🇨🇻','Curazao':'🇨🇼','Jordania':'🇯🇴','Uzbekistán':'🇺🇿',
};
const Bandera = ({ equipo, size=28 }) => {
  const [err, setErr] = useState(false);
  const key = BANDERA_KEY[equipo];
  if (!key || err)
    return <span style={{ fontSize:size*0.75, lineHeight:1 }}>{EMOJIS[equipo]||''}</span>;
  return <img src={`/banderas/${key}.jpg`} alt={equipo} onError={() => setErr(true)}
    style={{ width:size, height:Math.round(size*0.67), objectFit:'cover', borderRadius:3, border:'1px solid rgba(255,255,255,0.1)' }} />;
};

// ── Traducciones ──────────────────────────────────────────────────────────────
const NOMBRE_ES = {
  'Mexico':'México','Brazil':'Brasil','France':'Francia','Spain':'España',
  'Germany':'Alemania','England':'Inglaterra','Netherlands':'Países Bajos',
  'Belgium':'Bélgica','Italy':'Italia','Croatia':'Croacia','USA':'Estados Unidos',
  'Japan':'Japón','Korea Republic':'Corea del Sur','Morocco':'Marruecos',
  'Canada':'Canadá','Switzerland':'Suiza','Denmark':'Dinamarca','Turkey':'Turquía',
  'Scotland':'Escocia','Saudi Arabia':'Arabia Saudita','Panama':'Panamá',
  'Jamaica':'Jamaica','Honduras':'Honduras','Cameroon':'Camerún','Egypt':'Egipto',
  'New Zealand':'Nueva Zelanda','Sweden':'Suecia','South Africa':'Sudáfrica',
  'Haiti':'Haití','Czechia':'Chequia','Norway':'Noruega','Algeria':'Argelia',
  'Ghana':'Ghana','DR Congo':'Congo DR','Congo DR':'Congo DR',
  'Costa Rica':'Costa Rica','Iran':'Irán','Serbia':'Serbia','Denmark':'Dinamarca',
  'Bosnia-Herzegovina':'Bosnia','Ecuador':'Ecuador','Uruguay':'Uruguay',
  'Colombia':'Colombia','Argentina':'Argentina','Brazil':'Brasil','Portugal':'Portugal',
  'Paraguay':'Paraguay','Chile':'Chile','Venezuela':'Venezuela','Nigeria':'Nigeria',
  'Senegal':'Senegal','Mali':'Mali','Iraq':'Irak','Austria':'Austria','Norway':'Noruega',
};
const SELECCION_ES = {
  'Mexico':'México','Brazil':'Brasil','France':'Francia','Spain':'España',
  'Germany':'Alemania','England':'Inglaterra','Netherlands':'Países Bajos',
  'Belgium':'Bélgica','Italy':'Italia','Croatia':'Croacia','USA':'Estados Unidos',
  'Japan':'Japón','Korea Republic':'Corea del Sur','Morocco':'Marruecos',
  'Canada':'Canadá','Switzerland':'Suiza','Denmark':'Dinamarca','Turkey':'Turquía',
  'Scotland':'Escocia','Saudi Arabia':'Arabia Saudita','Panama':'Panamá',
  'Jamaica':'Jamaica','Honduras':'Honduras','Cameroon':'Camerún','Egypt':'Egipto',
  'New Zealand':'Nueva Zelanda','Sweden':'Suecia','South Africa':'Sudáfrica',
  'Haiti':'Haití','Czechia':'Chequia','Norway':'Noruega','Algeria':'Argelia',
  'Ghana':'Ghana','DR Congo':'DR Congo','Costa Rica':'Costa Rica','Iran':'Irán',
  'Bosnia-Herzegovina':'Bosnia y Herzegovina','Bosnia':'Bosnia y Herzegovina',
  'Bosnia y Herzegovina':'Bosnia y Herzegovina',
  'Iraq':'Iraq','Serbia':'Serbia','Congo DR':'DR Congo',
};
const nombreEs = n => NOMBRE_ES[n] || n;

const horaAR = iso => {
  if (!iso) return '';
  return new Date(iso).toLocaleString('es-AR',{
    day:'2-digit',month:'2-digit',hour:'2-digit',minute:'2-digit',
    timeZone:'America/Argentina/Buenos_Aires',
  });
};

// ── Puntos ────────────────────────────────────────────────────────────────────
const calcularPuntos = (d, pos) => {
  const p    = pos?.toUpperCase();
  const base = Math.round(parseFloat(d.sofascore) || 0);
  let bonus  = 0;
  if (d.goles > 0)             bonus += d.goles * (p==='DEF'?9:p==='ARQ'?12:p==='VOL'?6:4);
  if (d.gol_penal > 0)         bonus += d.gol_penal * 3;
  if (d.asistencias > 0)       bonus += d.asistencias * (p==='ARQ'?5:p==='DEF'?4:2);
  if (d.gol_de_oro)            bonus += 5;
  if (d.figura)                bonus += 4;
  if (d.valla_invicta)         bonus += p==='ARQ'?3:p==='DEF'?2:0;
  if (d.penal_atajado > 0)     bonus += d.penal_atajado * 6;
  if (d.penal_errado > 0)      bonus -= d.penal_errado * 4;
  if (d.gol_contra > 0)        bonus -= d.gol_contra * 3;
  if (d.goles_recibidos > 0 && p==='ARQ') bonus -= Math.floor(d.goles_recibidos / 2);
  if (d.amarilla)              bonus -= 2;
  if (d.roja)                  bonus -= 4;

  // ── Bonos por stats Sofascore (+1 c/u) ────────────────────────────────────
  // ARQ: +1 por cada 5 paradas fuera del área
  if (p==='ARQ' && (d.paradas||0) >= 5)         bonus += Math.floor((d.paradas||0) / 5);
  // ARQ: +2 por cada 5 paradas dentro del área
  if (p==='ARQ' && (d.paradas_dentro||0) >= 5)  bonus += Math.floor((d.paradas_dentro||0) / 5) * 2;
  // DEF: +1 por cada 6 despejes, +1 por cada 8 duelos aéreos
  if (p==='DEF' && (d.despejes||0) >= 6)        bonus += Math.floor((d.despejes||0) / 6);
  if (p==='DEF' && (d.duelos_aereos||0) >= 8)   bonus += Math.floor((d.duelos_aereos||0) / 8);
  // VOL: +1 por cada 50 pases precisos, +1 por cada 4 pases clave
  if (p==='VOL' && (d.pases_precisos||0) >= 50) bonus += Math.floor((d.pases_precisos||0) / 50);
  if (p==='VOL' && (d.pases_clave||0) >= 4)     bonus += Math.floor((d.pases_clave||0) / 4);
  // DEL: +1 por cada 4 tiros al arco, +1 por cada 4 pases clave
  if (p==='DEL' && (d.tiros_arco||0) >= 4)      bonus += Math.floor((d.tiros_arco||0) / 4);
  if (p==='DEL' && (d.pases_clave||0) >= 4)     bonus += Math.floor((d.pases_clave||0) / 4);

  return { puntos_base:base, puntos_bonus:bonus, puntos_total:base+bonus };
};

// ── Toggle ────────────────────────────────────────────────────────────────────
const Toggle = ({ checked, onChange, label, color='#00f2ff', size=28 }) => (
  <label style={{ display:'flex', alignItems:'center', gap:'5px', cursor:'pointer', userSelect:'none' }}>
    <div onClick={() => onChange(!checked)}
      style={{ width:`${size}px`, height:`${Math.round(size*0.6)}px`, borderRadius:`${size}px`, background:checked?color:'#1e293b', border:`1px solid ${checked?color:'#334155'}`, position:'relative', transition:'0.18s', flexShrink:0 }}>
      <div style={{ position:'absolute', top:'2px', left:checked?`${size-Math.round(size*0.6)+2}px`:'2px', width:`${Math.round(size*0.6)-4}px`, height:`${Math.round(size*0.6)-4}px`, borderRadius:'50%', background:checked?'#000':'#475569', transition:'0.18s' }} />
    </div>
    {label && <span style={{ color:checked?color:'#475569', fontSize:'0.72rem', fontWeight:'bold', whiteSpace:'nowrap' }}>{label}</span>}
  </label>
);

const NumIn = ({ value, onChange, min=0, max=9, w=44, color }) => (
  <input type="number" min={min} max={max} value={value}
    onChange={e => onChange(e.target.value)}
    onFocus={e => { if(e.target.value==='0') e.target.select(); }}
    style={{ background:'#080d14', border:`1px solid ${color||'#1e293b'}`, borderRadius:'5px', color: color||'#e2e8f0', fontSize:'0.82rem', padding:'4px 6px', width:`${w}px`, textAlign:'center', boxSizing:'border-box', fontWeight: color?'bold':'normal' }} />
);

// ── Fila jugador — LAYOUT HORIZONTAL COMPLETO ────────────────────────────────
const FilaJugador = ({ jugador, jornada, onGuardado, onCambio }) => {
  const pos = jugador.posicion?.sigla || '?';
  const esARQ = pos === 'ARQ';
  const esDEF = pos === 'DEF';
  const esVOL = pos === 'VOL';
  const esDEL = pos === 'DEL';
  const tieneValla = esARQ || esDEF;
  const tienePenal = true; // todos pueden errar penal
  const tieneAtajado = esARQ;

  const [form, setForm] = useState({
    sofascore:'', goles:0, asistencias:0,
    amarilla:false, roja:false, gol_de_oro:false,
    valla_invicta:false, figura:false,
    penal_atajado:0, penal_errado:0,
    gol_contra:0, goles_recibidos:0,
    paradas:0, paradas_dentro:0, despejes:0, duelos_aereos:0,
    pases_precisos:0, pases_clave:0, tiros_arco:0,
  });
  const [guardando, setGuardando] = useState(false);
  const [guardado, setGuardado]   = useState(false);

  // Cargar datos ya guardados al montar
  React.useEffect(() => {
    const cargar = async () => {
      const { data } = await supabase.from('jugador_puntos_fecha')
        .select('*').eq('jugador_id', jugador.id).eq('jornada', jornada).maybeSingle();
      if (data) {
        setForm({
          sofascore:       data.sofascore != null ? String(data.sofascore) : '',
          goles:           data.goles || 0,
          asistencias:     data.asistencias || 0,
          amarilla:        (data.amarillas || 0) > 0,
          roja:            (data.rojas || 0) > 0,
          gol_de_oro:      data.gol_de_oro || false,
          valla_invicta:   data.valla_invicta || false,
          figura:          data.figura || false,
          penal_atajado:   data.penal_atajado || 0,
          penal_errado:    data.penal_errado || 0,
          gol_contra:      data.gol_contra || 0,
          goles_recibidos: data.goles_recibidos || 0,
          paradas:         data.paradas || 0,
          paradas_dentro:  data.paradas_dentro || 0,
          despejes:        data.despejes || 0,
          duelos_aereos:   data.duelos_aereos || 0,
          pases_precisos:  data.pases_precisos || 0,
          pases_clave:     data.pases_clave || 0,
          tiros_arco:      data.tiros_arco || 0,
        });
        setGuardado(true);
      }
    };
    cargar();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jugador.id, jornada]);

  const preview = form.sofascore !== ''
    ? calcularPuntos({ ...form, sofascore:parseFloat(form.sofascore)||0 }, pos)
    : null;

  const guardar = async () => {
    if (form.sofascore === '') return;
    setGuardando(true);
    const pts = calcularPuntos({ ...form, sofascore:parseFloat(form.sofascore) }, pos);
    const { error } = await supabase.from('jugador_puntos_fecha').upsert({
      jugador_id:    jugador.id, jornada,
      sofascore:     parseFloat(form.sofascore),
      puntos_base:   pts.puntos_base, puntos_bonus:pts.puntos_bonus, puntos_total:pts.puntos_total,
      goles:         parseInt(form.goles)||0, asistencias:parseInt(form.asistencias)||0,
      amarillas:     form.amarilla?1:0, rojas:form.roja?1:0,
      gol_de_oro:    form.gol_de_oro, valla_invicta:form.valla_invicta,
      figura:        form.figura,
      penal_atajado: parseInt(form.penal_atajado)||0, penal_errado:parseInt(form.penal_errado)||0,
      gol_contra:    parseInt(form.gol_contra)||0,
      goles_recibidos: parseInt(form.goles_recibidos)||0,
      paradas:       parseInt(form.paradas)||0,
      paradas_dentro: parseInt(form.paradas_dentro)||0,
      despejes:      parseInt(form.despejes)||0,
      duelos_aereos: parseInt(form.duelos_aereos)||0,
      pases_precisos: parseInt(form.pases_precisos)||0,
      pases_clave:   parseInt(form.pases_clave)||0,
      tiros_arco:    parseInt(form.tiros_arco)||0,
    }, { onConflict:'jugador_id,jornada' });
    setGuardando(false);
    if (!error) { setGuardado(true); onGuardado?.(); }
  };

  const f = (k, v) => {
    setGuardado(false);
    const nuevo = { ...form, [k]: v };
    setForm(nuevo);
    onCambio?.(jugador.id, nuevo);
  };

  const POS_COLOR = { DEL:'#ef4444', VOL:'#3b82f6', DEF:'#22c55e', ARQ:'#f59e0b' };
  const pc = POS_COLOR[pos] || '#64748b';

  return (
    <div style={{ background:guardado?'#22c55e06':'#080d14', border:`1px solid ${guardado?'#22c55e33':'#1e293b'}`, borderRadius:'8px', marginBottom:'5px' }}>
      <div style={{ display:'flex', alignItems:'center', gap:'8px', padding:'8px 12px', flexWrap:'wrap' }}>

        {/* Posición + Nombre */}
        <div style={{ display:'flex', alignItems:'center', gap:'6px', minWidth:'180px', flex:'1 1 180px' }}>
          <span style={{ background:pc+'22', color:pc, border:`1px solid ${pc}44`, borderRadius:'4px', padding:'2px 6px', fontSize:'0.65rem', fontWeight:'bold', flexShrink:0 }}>{pos}</span>
          <span style={{ color:'#e2e8f0', fontSize:'0.88rem', fontWeight:'500' }}
            title={`${jugador.nombre} ${jugador.apellido}`}>
            {jugador.nombre} {jugador.apellido}
          </span>
        </div>

        {/* Pts base (SofaScore) */}
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'2px', flexShrink:0 }}>
          <span style={{ color:'#334155', fontSize:'0.58rem', textTransform:'uppercase', letterSpacing:'0.5px' }}>Pts Base</span>
          <input type="number" step="0.1" min="0" max="10" placeholder="7.5"
            value={form.sofascore} onChange={e => f('sofascore', e.target.value)}
            onFocus={e => { if(e.target.value==='0') e.target.select(); }}
            style={{ background:'#0a0f19', border:`1px solid ${form.sofascore!==''?'#00f2ff55':'#1e293b'}`, borderRadius:'6px', color:'#00f2ff', fontSize:'0.88rem', padding:'4px 0', width:'58px', textAlign:'center', fontWeight:'bold' }} />
        </div>

        {/* Goles */}
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'2px', flexShrink:0 }}>
          <span style={{ color:'#334155', fontSize:'0.58rem', textTransform:'uppercase' }}>Goles</span>
          <div style={{ display:'flex', alignItems:'center', gap:'3px' }}>
            <span style={{ fontSize:'0.78rem' }}></span>
            <NumIn value={form.goles} onChange={v => f('goles', v)} />
          </div>
        </div>

        {/* Asistencias */}
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'2px', flexShrink:0 }}>
          <span style={{ color:'#334155', fontSize:'0.58rem', textTransform:'uppercase' }}>Asist</span>
          <div style={{ display:'flex', alignItems:'center', gap:'3px' }}>
            <span style={{ fontSize:'0.78rem' }}>🅰️</span>
            <NumIn value={form.asistencias} onChange={v => f('asistencias', v)} />
          </div>
        </div>

        {/* Gol de penal (solo no ARQ) */}
        {!esARQ && (
          <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'2px', flexShrink:0 }}>
            <span style={{ color:'#334155', fontSize:'0.58rem', textTransform:'uppercase' }}>G.Penal</span>
            <NumIn value={form.gol_penal} onChange={v => f('gol_penal', v)} />
          </div>
        )}

        {/* Amarilla */}
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'4px', flexShrink:0 }}>
          <span style={{ color:'#334155', fontSize:'0.58rem', textTransform:'uppercase' }}>Amar</span>
          <Toggle checked={form.amarilla} onChange={v => f('amarilla', v)} color="#f59e0b" />
        </div>

        {/* Roja */}
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'4px', flexShrink:0 }}>
          <span style={{ color:'#334155', fontSize:'0.58rem', textTransform:'uppercase' }}>Roja</span>
          <Toggle checked={form.roja} onChange={v => f('roja', v)} color="#ef4444" />
        </div>

        {/* Gol de Oro */}
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'4px', flexShrink:0 }}>
          <span style={{ color:'#334155', fontSize:'0.58rem', textTransform:'uppercase' }}>Gol Oro</span>
          <Toggle checked={form.gol_de_oro} onChange={v => f('gol_de_oro', v)} label="⭐" color="#f59e0b" />
        </div>

        {/* Figura */}
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'4px', flexShrink:0 }}>
          <span style={{ color:'#334155', fontSize:'0.58rem', textTransform:'uppercase' }}>Figura</span>
          <Toggle checked={form.figura} onChange={v => f('figura', v)} label="🏅" color="#00f2ff" />
        </div>

        {/* Valla invicta — solo ARQ y DEF */}
        {tieneValla && (
          <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'4px', flexShrink:0 }}>
            <span style={{ color:'#334155', fontSize:'0.58rem', textTransform:'uppercase' }}>Valla</span>
            <Toggle checked={form.valla_invicta} onChange={v => f('valla_invicta', v)} label="🧤" color="#00f2ff" />
          </div>
        )}

        {/* Penal atajado — solo ARQ */}
        {tieneAtajado && (
          <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'2px', flexShrink:0 }}>
            <span style={{ color:'#334155', fontSize:'0.58rem', textTransform:'uppercase' }}>P.Ataj</span>
            <NumIn value={form.penal_atajado} onChange={v => f('penal_atajado', v)} max={5} />
          </div>
        )}

        {/* Penal errado — todos */}
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'2px', flexShrink:0 }}>
          <span style={{ color:'#334155', fontSize:'0.58rem', textTransform:'uppercase' }}>P.Err</span>
          <NumIn value={form.penal_errado} onChange={v => f('penal_errado', v)} max={5} />
        </div>

        {/* Gol en contra — todos */}
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'2px', flexShrink:0 }}>
          <span style={{ color:'#ef444488', fontSize:'0.58rem', textTransform:'uppercase' }}>G.Cnt</span>
          <NumIn value={form.gol_contra} onChange={v => f('gol_contra', v)} max={5} />
        </div>

        {/* Goles recibidos — solo ARQ */}
        {esARQ && (
          <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'2px', flexShrink:0 }}>
            <span style={{ color:'#ef444488', fontSize:'0.58rem', textTransform:'uppercase' }}>G.Rec</span>
            <NumIn value={form.goles_recibidos} onChange={v => f('goles_recibidos', v)} max={20} />
          </div>
        )}

        {/* ── Stats Sofascore (bonos +1) ── */}
        {esARQ && (
          <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'2px', flexShrink:0 }}>
            <span style={{ color:'#a855f788', fontSize:'0.58rem', textTransform:'uppercase' }}>Parad</span>
            <NumIn value={form.paradas} onChange={v => f('paradas', v)} max={20} color={form.paradas>=5?'#a855f7':'#334155'} />
            <NumIn value={form.paradas_dentro} onChange={v => f('paradas_dentro', v)} max={20} color={form.paradas_dentro>=5?'#22c55e':'#334155'} label="P.Area" />
          </div>
        )}
        {esDEF && (
          <>
            <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'2px', flexShrink:0 }}>
              <span style={{ color:'#a855f788', fontSize:'0.58rem', textTransform:'uppercase' }}>Desp</span>
              <NumIn value={form.despejes} onChange={v => f('despejes', v)} max={30} color={form.despejes>=6?'#a855f7':'#334155'} />
            </div>
            <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'2px', flexShrink:0 }}>
              <span style={{ color:'#a855f788', fontSize:'0.58rem', textTransform:'uppercase' }}>DuelA</span>
              <NumIn value={form.duelos_aereos} onChange={v => f('duelos_aereos', v)} max={30} color={form.duelos_aereos>=8?'#a855f7':'#334155'} />
            </div>
          </>
        )}
        {esVOL && (
          <>
            <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'2px', flexShrink:0 }}>
              <span style={{ color:'#a855f788', fontSize:'0.58rem', textTransform:'uppercase' }}>Pases</span>
              <NumIn value={form.pases_precisos} onChange={v => f('pases_precisos', v)} max={150} color={form.pases_precisos>=50?'#a855f7':'#334155'} />
            </div>
            <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'2px', flexShrink:0 }}>
              <span style={{ color:'#a855f788', fontSize:'0.58rem', textTransform:'uppercase' }}>P.Clv</span>
              <NumIn value={form.pases_clave} onChange={v => f('pases_clave', v)} max={20} color={form.pases_clave>=4?'#a855f7':'#334155'} />
            </div>
          </>
        )}
        {esDEL && (<>
          <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'2px', flexShrink:0 }}>
            <span style={{ color:'#a855f788', fontSize:'0.58rem', textTransform:'uppercase' }}>TiroA</span>
            <NumIn value={form.tiros_arco} onChange={v => f('tiros_arco', v)} max={15} color={form.tiros_arco>=4?'#a855f7':'#334155'} />
          </div>
          <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'2px', flexShrink:0 }}>
            <span style={{ color:'#a855f788', fontSize:'0.58rem', textTransform:'uppercase' }}>P.Clv</span>
            <NumIn value={form.pases_clave} onChange={v => f('pases_clave', v)} max={20} color={form.pases_clave>=4?'#a855f7':'#334155'} />
          </div>
        </>)}

        {/* Puntos preview */}
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:'2px', flexShrink:0, marginLeft:'auto' }}>
          <span style={{ color:'#334155', fontSize:'0.58rem', textTransform:'uppercase' }}>Total</span>
          <span style={{ color: preview ? '#00f2ff' : '#334155', fontWeight:'bold', fontSize:'1rem', minWidth:'36px', textAlign:'center' }}>
            {preview ? preview.puntos_total : '—'}
          </span>
        </div>

        {/* Guardar */}
        <button onClick={guardar} disabled={guardando || form.sofascore===''}
          style={{ background:guardado?'#22c55e22':form.sofascore!==''?'#00f2ff22':'#0a0f19', border:`1px solid ${guardado?'#22c55e':form.sofascore!==''?'#00f2ff':'#1e293b'}`, color:guardado?'#22c55e':form.sofascore!==''?'#00f2ff':'#334155', borderRadius:'6px', padding:'7px 14px', cursor:form.sofascore===''?'default':'pointer', fontSize:'0.8rem', fontWeight:'bold', whiteSpace:'nowrap', flexShrink:0 }}>
          {guardando?'...':guardado?'✓ OK':'Guardar'}
        </button>

      </div>

      {/* Desglose de puntos — solo cuando hay preview */}
      {preview && (
        <div style={{ padding:'4px 12px 6px', borderTop:'1px solid #0f172a', display:'flex', gap:'12px', flexWrap:'wrap' }}>
          <span style={{ color:'#334155', fontSize:'0.7rem' }}>Base: <b style={{ color:'#00f2ff' }}>{preview.puntos_base}</b></span>
          <span style={{ color:'#334155', fontSize:'0.7rem' }}>Bonus: <b style={{ color:'#f59e0b' }}>{preview.puntos_bonus>=0?'+':''}{preview.puntos_bonus}</b></span>
          <span style={{ color:'#334155', fontSize:'0.7rem' }}>Total: <b style={{ color:'#22c55e', fontSize:'0.82rem' }}>{preview.puntos_total}</b></span>
          <span style={{ color:'#1e293b', fontSize:'0.68rem' }}>Capitán: {preview.puntos_base*2+preview.puntos_bonus} pts</span>
        </div>
      )}
    </div>
  );
};

// ── Componente principal ──────────────────────────────────────────────────────
const AdminPuntos = ({ session, esAdmin }) => {
  const [jornada, setJornada]             = useState(1);
  const [partidos, setPartidos]           = useState([]);
  const [adminTab, setAdminTab]           = useState('partidos');
  // Cruces panel
  const [cruceFase, setCruceFase]         = useState(4);
  const [crucePartidos, setCrucePartidos] = useState([]);
  const [cruceCargando, setCruceCargando] = useState(false);
  const [cruceMensaje, setCruceMensaje]   = useState('');
  const [cruceEdits, setCruceEdits]       = useState({}); // { [id]: { local, visitante, hora } }
  const [cruceSelLista, setCruceSelLista] = useState([]);
  const [cruceDropActivo, setCruceDropActivo] = useState(null);
  useEffect(() => {
    supabase.from('jugadores').select('seleccion').eq('contexto','mundial').neq('seleccion',null)
      .then(({ data }) => {
        const unicas = [...new Set((data||[]).map(j => j.seleccion))].sort();
        setCruceSelLista(unicas);
      });
  }, []);
  const [golTabla, setGolTabla]               = useState([]);
  const [golBusqueda, setGolBusqueda]         = useState('');
  const [golJugador, setGolJugador]           = useState(null);
  const [golGoles, setGolGoles]               = useState(0);
  const [golAsist, setGolAsist]               = useState(0);
  const [golGuardando, setGolGuardando]       = useState(false);
  const [golMensaje, setGolMensaje]           = useState('');
  const [golDropdown, setGolDropdown]         = useState([]);
  // Status panel
  const [stBusqueda, setStBusqueda]           = useState('');
  const [stDropdown, setStDropdown]           = useState([]);
  const [stSeleccion, setStSeleccion]         = useState(null);
  const [stJugadores, setStJugadores]         = useState([]); // [{ id, nombre, apellido, posicion, status }]
  const [stCambios, setStCambios]             = useState({}); // { [id]: 'titular'|'suplente'|'duda'|'lesionado'|'no_juega' }
  const [stGuardando, setStGuardando]         = useState(false);
  const [stMensaje, setStMensaje]             = useState('');
  const [partidoActivo, setPartidoActivo] = useState(null);
  const [equipoIdx, setEquipoIdx]         = useState(0); // 0 = local, 1 = visitante
  const [jugadores, setJugadores]         = useState([]);
  const [loadingPartidos, setLoadingPartidos]   = useState(true);
  const [loadingJugadores, setLoadingJugadores] = useState(false);
  const [guardadosCount, setGuardadosCount]     = useState(0);

  const cambiarEquipo = (idx) => {
    setEquipoIdx(idx);
    setPendientesEquipo({});
    setGuardadosTodosOk(false);
  };

  // Resetear resultado al cambiar de partido
  React.useEffect(() => {
    if (partidoActivo) {
      setResultadoLocal(partidoActivo.goles_local != null ? String(partidoActivo.goles_local) : '');
      setResultadoVisit(partidoActivo.goles_visitante != null ? String(partidoActivo.goles_visitante) : '');
      setResultadoOk(false);
    }
  }, [partidoActivo?.id]);
  const [pendientesEquipo, setPendientesEquipo] = useState({}); // { jugadorId: formData }
  const [guardandoTodos, setGuardandoTodos]     = useState(false);
  const [guardadosTodosOk, setGuardadosTodosOk] = useState(false);
  const [resultadoLocal, setResultadoLocal]     = useState('');
  const [resultadoVisit, setResultadoVisit]     = useState('');
  const [guardandoResult, setGuardandoResult]   = useState(false);
  const [resultadoOk, setResultadoOk]           = useState(false);

  const guardarResultadoPartido = async () => {
    if (resultadoLocal === '' || resultadoVisit === '' || !partidoActivo) return;
    setGuardandoResult(true);
    const gl = parseInt(resultadoLocal), gv = parseInt(resultadoVisit);
    const { error } = await supabase.from('mundial_partidos').update({
      goles_local: gl, goles_visitante: gv, estado: 'finalizado'
    }).eq('id', partidoActivo.id);
    if (!error) {
      setPartidoActivo(prev => ({ ...prev, goles_local: gl, goles_visitante: gv, estado: 'finalizado' }));
      // Calcular prode automáticamente para este partido
      await calcularProdePartido(partidoActivo.id, gl, gv);
      // Propagar ganador al partido siguiente si existe
      if (partidoActivo.partido_siguiente_id) {
        const ganador = gl > gv ? partidoActivo.equipo_local
                      : gv > gl ? partidoActivo.equipo_visitante
                      : null; // empate en tiempo reg no debería pasar en eliminatorias
        if (ganador) {
          const campo = partidoActivo.es_local_en_siguiente ? 'equipo_local' : 'equipo_visitante';
          await supabase.from('mundial_partidos')
            .update({ [campo]: ganador })
            .eq('id', partidoActivo.partido_siguiente_id);
        }
      }
      setResultadoOk(true);
      setTimeout(() => setResultadoOk(false), 3000);
    }
    setGuardandoResult(false);
  };

  const calcularProdePartido = async (partidoId, gl, gv) => {
    const difReal = gl - gv;
    const { data: prons } = await supabase
      .from('prode_pronosticos')
      .select('id, goles_local, goles_visitante, user_id, torneo_id')
      .eq('mundial_partido_id', partidoId);

    for (const pron of (prons || [])) {
      const pl = pron.goles_local, pv = pron.goles_visitante;
      const difPron = pl - pv;
      let tipo, puntos;
      if (pl === gl && pv === gv)                                                       { tipo = 'exacto';     puntos = 5; }
      else if (difPron === difReal)                                                     { tipo = 'diferencia'; puntos = 3; }
      else if ((pl > pv && gl > gv) || (pl < pv && gl < gv) || (pl === pv && gl === gv)) { tipo = 'parcial';    puntos = 2; }
      else                                                                              { tipo = 'error';      puntos = 0; }
      await supabase.from('prode_pronosticos')
        .update({ tipo_acierto: tipo, puntos_ganados: puntos }).eq('id', pron.id);
    }

    // Recalcular totales de participantes afectados
    const torneosAfectados = [...new Set((prons || []).map(p => p.torneo_id))];
    for (const torneoId of torneosAfectados) {
      const { data: parts } = await supabase
        .from('prode_participantes').select('id, user_id').eq('torneo_id', torneoId);
      for (const part of (parts || [])) {
        const { data: suma } = await supabase
          .from('prode_pronosticos').select('puntos_ganados')
          .eq('torneo_id', torneoId).eq('user_id', part.user_id);
        const total = (suma || []).reduce((acc, p) => acc + (p.puntos_ganados || 0), 0);
        await supabase.from('prode_participantes').update({ puntos_totales: total }).eq('id', part.id);
      }
    }

    // Medallas por exactos
    const usuariosExactos = [...new Set((prons || []).filter(p => p.tipo_acierto !== 'exacto').map(p => p.user_id))];
    // (se procesan en calcularPuntosProde completo — acá solo actualizamos resultados en tiempo real)
  };

  const guardarTodosEquipo = async () => {
    const entradas = Object.entries(pendientesEquipo).filter(([, f]) => f.sofascore !== '');
    if (!entradas.length) return;
    setGuardandoTodos(true);
    let count = 0;
    for (const [jugadorId, form] of entradas) {
      const jugador = jugadores.find(j => j.id === jugadorId);
      const pos = jugador?.posicion?.sigla || '?';
      const pts = calcularPuntos({ ...form, sofascore: parseFloat(form.sofascore) }, pos);
      const { error } = await supabase.from('jugador_puntos_fecha').upsert({
        jugador_id: jugadorId, jornada,
        sofascore: parseFloat(form.sofascore),
        puntos_base: pts.puntos_base, puntos_bonus: pts.puntos_bonus, puntos_total: pts.puntos_total,
        goles: parseInt(form.goles)||0, asistencias: parseInt(form.asistencias)||0,
        amarillas: form.amarilla?1:0, rojas: form.roja?1:0,
        gol_de_oro: form.gol_de_oro, valla_invicta: form.valla_invicta,
        figura: form.figura,
        penal_atajado: parseInt(form.penal_atajado)||0, penal_errado: parseInt(form.penal_errado)||0,
        gol_contra: parseInt(form.gol_contra)||0, goles_recibidos: parseInt(form.goles_recibidos)||0,
      }, { onConflict: 'jugador_id,jornada' });
      if (!error) count++;
    }
    setGuardandoTodos(false);
    setGuardadosTodosOk(true);
    setGuardadosCount(v => v + count);
    setPendientesEquipo({});
    setTimeout(() => setGuardadosTodosOk(false), 3000);
  };

  // Distribución de puntos
  const [jornadaTorneo, setJornadaTorneo] = useState(1);
  const [distribuyendo, setDistribuyendo] = useState(false);
  const [distribuyendoLibre, setDistribuyendoLibre] = useState(false);
  const [distribucionLog, setDistribucionLog] = useState(null);
  const [resolviendoRanked, setResolviendoRanked] = useState(false);
  const [rankedLog, setRankedLog] = useState(null);
  const [resolviendoGuerras, setResolviendoGuerras] = useState(false);
  const [guerrasLog, setGuerrasLog] = useState(null);
  const [asignandoTorneos, setAsignandoTorneos] = useState(false);
  const [asignacionLog, setAsignacionLog] = useState(null);
  const [cerrandoFecha, setCerrandoFecha]   = useState(false);
  const [cierreLog, setCierreLog]           = useState(null);
  const [abriendoVentana, setAbriendoVentana] = useState(false);

  const abrirVentanaSiguiente = async () => {
    if (!window.confirm(`¿Abrir la ventana de la Fecha ${jornadaTorneo + 1} ahora? La gente podrá armar su equipo.`)) return;
    setAbriendoVentana(true);
    await supabase.from('ventana_transferencias')
      .update({ apertura: new Date().toISOString(), activa: true }).eq('numero_fecha', jornadaTorneo + 1);

    // Crear drafts libres de j+1 copiando equipo de j actual para que no empiecen de 0
    const { data: draftsLibres } = await supabase.from('drafts')
      .select('user_id, equipo_libre, formacion_libre, capitan_index_libre')
      .eq('jornada', jornadaTorneo)
      .not('equipo_libre', 'is', null);
    if (draftsLibres?.length) {
      const nuevos = draftsLibres.map(d => ({
        user_id: d.user_id,
        jornada: jornadaTorneo + 1,
        equipo_libre: d.equipo_libre,
        formacion_libre: d.formacion_libre,
        capitan_index_libre: d.capitan_index_libre,
        confirmado: false,
        ruleta_girada: false,
      }));
      await supabase.from('drafts').upsert(nuevos, { onConflict: 'user_id,jornada', ignoreDuplicates: true });
    }

    setAbriendoVentana(false);
    alert(`✓ Ventana Fecha ${jornadaTorneo + 1} abierta. La gente ya puede armar su equipo.`);
  };

  const cerrarFecha = async () => {
    if (!window.confirm(`¿Cerrar la Fecha ${jornadaTorneo}? Esto desactiva la ventana de transferencias y habilita la siguiente. No se puede deshacer.`)) return;
    setCerrandoFecha(true); setCierreLog(null);
    try {
      // 1. Cerrar ventana de transferencias actual
      await supabase.from('ventana_transferencias')
        .update({ activa: false }).eq('numero_fecha', jornadaTorneo);

      // 2. Activar ventana siguiente (mantiene su apertura original)
      await supabase.from('ventana_transferencias')
        .update({ activa: true }).eq('numero_fecha', jornadaTorneo + 1);

      // 3. Cerrar torneo_fechas activas de esta jornada
      await supabase.from('torneo_fechas')
        .update({ activa: false, cerrada: true }).eq('numero_fecha', jornadaTorneo).eq('activa', true);

      // 4. Activar torneo_fechas de la jornada siguiente
      const { data: proximasFechas } = await supabase.from('torneo_fechas')
        .select('id').eq('numero_fecha', jornadaTorneo + 1);
      if (proximasFechas?.length) {
        await supabase.from('torneo_fechas')
          .update({ activa: true }).in('id', proximasFechas.map(f => f.id));
      }

      setCierreLog({ ok: true, msg: `✓ Fecha ${jornadaTorneo} cerrada. Fecha ${jornadaTorneo + 1} activa. Ya podés distribuir puntos.` });
    } catch(err) {
      setCierreLog({ ok: false, msg: 'Error: ' + err.message });
    }
    setCerrandoFecha(false);
  };

  const autoAsignarTorneos = async () => {
    setAsignandoTorneos(true);
    setAsignacionLog(null);
    try {
      // 1. Traer usuarios con draft confirmado en jornada activa
      const { data: ventana } = await supabase.from('ventana_transferencias').select('numero_fecha').eq('activa', true).order('numero_fecha', { ascending: false }).limit(1).single();
      const jornada = ventana?.numero_fecha || 1;

      const { data: drafts } = await supabase.from('drafts')
        .select('user_id').eq('jornada', jornada).eq('confirmado', true);
      if (!drafts?.length) { setAsignacionLog({ ok: false, msg: 'No hay usuarios con equipo confirmado en jornada ' + jornada }); return; }

      const userIds = drafts.map(d => d.user_id);

      // 2. Ver cuáles YA están en un torneo DTXI TÁCTICO
      const { data: yaEnDTXI } = await supabase
        .from('torneo_participantes')
        .select('user_id, torneo:torneos(nombre)')
        .in('user_id', userIds);

      const enDTXI = new Set(
        (yaEnDTXI || [])
          .filter(p => p.torneo?.nombre?.startsWith('DTXI TÁCTICO'))
          .map(p => p.user_id)
      );

      // 3. Filtrar los que necesitan ser asignados
      const sinTorneo = userIds.filter(id => !enDTXI.has(id));
      if (!sinTorneo.length) { setAsignacionLog({ ok: true, msg: '✓ Todos los usuarios ya están en un torneo DTXI TÁCTICO' }); return; }

      // 4. Buscar torneos DTXI existentes con menos de 10 participantes
      const { data: torneosDTXI } = await supabase
        .from('torneos')
        .select('id, nombre, torneo_participantes(user_id)')
        .like('nombre', 'DTXI TÁCTICO%')
        .eq('tipo', 'tactico');

      // Mapear torneos con espacio disponible
      const torneosConEspacio = (torneosDTXI || [])
        .map(t => ({ id: t.id, nombre: t.nombre, count: t.torneo_participantes?.length || 0 }))
        .filter(t => t.count < 10)
        .sort((a, b) => b.count - a.count); // llenar los más llenos primero

      // 5. Asignar usuarios — llenar torneos existentes o crear nuevos
      let asignados = 0;
      let cola = [...sinTorneo];
      // Shuffle aleatorio
      cola.sort(() => Math.random() - 0.5);

      // Llenar torneos existentes con espacio
      for (const torneo of torneosConEspacio) {
        if (!cola.length) break;
        const espacios = 10 - torneo.count;
        const lote = cola.splice(0, espacios);
        const { data: perfis } = await supabase.from('perfiles').select('id, nickname').in('id', lote);
        const insertar = lote.map(uid => {
          const nick = perfis?.find(p => p.id === uid)?.nickname || 'Usuario';
          return { torneo_id: torneo.id, user_id: uid, nombre_usuario: nick };
        });
        await supabase.from('torneo_participantes').insert(insertar);
        asignados += lote.length;
      }

      // Crear nuevos torneos para los restantes (grupos de 5-10)
      let torneoNum = (torneosDTXI?.length || 0) + 1;
      while (cola.length >= 1) {
        const grupo = cola.splice(0, Math.min(10, Math.max(5, cola.length)));
        if (grupo.length < 5 && torneosDTXI?.length) {
          // Si quedan menos de 5, buscar el DTXI menos lleno y meterlos ahí
          const { data: menosLleno } = await supabase
            .from('torneos').select('id, torneo_participantes(user_id)')
            .like('nombre', 'DTXI TÁCTICO%').eq('tipo', 'tactico')
            .order('created_at', { ascending: true }).limit(1).single();
          if (menosLleno) {
            const { data: perfis } = await supabase.from('perfiles').select('id, nickname').in('id', grupo);
            await supabase.from('torneo_participantes').insert(
              grupo.map(uid => ({ torneo_id: menosLleno.id, user_id: uid, nombre_usuario: perfis?.find(p=>p.id===uid)?.nickname||'Usuario' }))
            );
            asignados += grupo.length;
            continue;
          }
        }

        // Crear nuevo torneo DTXI
        const nombre = `DTXI TÁCTICO #${torneoNum++}`;
        const cod = Math.random().toString(36).substring(2, 8).toUpperCase();
        const { data: nuevoTorneo } = await supabase.from('torneos').insert({
          nombre, tipo: 'tactico', creador_id: grupo[0],
          codigo_invitacion: cod, publico: false,
        }).select().single();

        if (nuevoTorneo) {
          // Crear 5 fechas para el torneo
          await supabase.from('torneo_fechas').insert(
            Array.from({ length: 5 }, (_, i) => ({
              torneo_id: nuevoTorneo.id, numero_fecha: i + 1,
              activa: i === 0, cerrada: false,
            }))
          );
          // Agregar participantes
          const { data: perfis } = await supabase.from('perfiles').select('id, nickname').in('id', grupo);
          await supabase.from('torneo_participantes').insert(
            grupo.map(uid => ({
              torneo_id: nuevoTorneo.id, user_id: uid,
              nombre_usuario: perfis?.find(p=>p.id===uid)?.nickname||'Usuario',
              casillero: 1,
            }))
          );
          asignados += grupo.length;
        }
      }

      setAsignacionLog({ ok: true, msg: `✓ ${asignados} usuarios asignados a torneos DTXI TÁCTICO` });

      // También inscribir todos al DTXI LIBRE #1 si no están ya
      const DTXI_LIBRE_ID = 'a1b2c3d4-e5f6-7890-abcd-ef1234567890';
      const { data: yaEnLibre } = await supabase.from('torneo_participantes').select('user_id').eq('torneo_id', DTXI_LIBRE_ID);
      const enLibre = new Set((yaEnLibre || []).map(p => p.user_id));
      const { data: todosPerfiles } = await supabase.from('perfiles').select('id, nickname');
      const sinLibre = (todosPerfiles || []).filter(p => !enLibre.has(p.id));
      if (sinLibre.length) {
        await supabase.from('torneo_participantes').insert(sinLibre.map(p => ({ torneo_id: DTXI_LIBRE_ID, user_id: p.id, nombre_usuario: p.nickname, casillero: 0 })));
      }
    } catch (err) {
      setAsignacionLog({ ok: false, msg: 'Error: ' + err.message });
    } finally {
      setAsignandoTorneos(false);
    }
  };

  const resolverGuerrasManuales = async () => {
    setResolviendoGuerras(true);
    setGuerrasLog(null);
    try {
      const { data, error } = await supabase.rpc('resolver_guerras_jornada', { p_jornada: jornadaTorneo });
      if (error) setGuerrasLog({ ok: false, msg: error.message });
      else setGuerrasLog({ ok: true, msg: '✓ ' + data });
    } catch(err) { setGuerrasLog({ ok: false, msg: err.message }); }
    setResolviendoGuerras(false);
  };

  const resolverRanked = async () => {
    setResolviendoRanked(true);
    setRankedLog(null);
    try {
      const { data, error } = await supabase.rpc('resolver_desafios_ranked', { p_jornada: jornadaTorneo });
      if (error) { setRankedLog({ ok: false, msg: error.message }); setResolviendoRanked(false); return; }

      // Otorgar hitos de ranked a todos los jugadores
      const { data: perfiles } = await supabase.from('perfiles').select('id, victorias_ranked, racha_ranked, rango_ranked');
      for (const p of (perfiles || [])) {
        const v = p.victorias_ranked || 0;
        const racha = p.racha_ranked || 0;
        const rango = p.rango_ranked || '';

        // Hitos por victorias
        // Ranked solo otorga medallas de ascenso desde RankedPage (ascenso_C/B/A/DTXI/campeon_dtxi)
        // No hay hitos por victorias ranked en esta función
        const hitosVictorias = []; // handled by RankedPage
        for (const h of hitosVictorias) {
          if (v >= h.n) {
            const { count } = await supabase.from('medallas_usuario').select('id', { count: 'exact', head: true }).eq('user_id', p.id).eq('nombre', h.nombre);
            if (!count) {
              await supabase.from('medallas_usuario').insert({ user_id: p.id, tipo: 'hito', subtipo: 'ranked', emoji: h.emoji, nombre: h.nombre, descripcion: h.desc, visible: true });
              await supabase.from('notificaciones').insert({ user_id: p.id, tipo: 'medalla', texto: `🏅 Nuevo hito: ${h.nombre}`, emoji: h.emoji, leida: false });
            }
          }
        }

        // Hitos por racha
        const hitosRacha = [
          { n: 3,  emoji: '🔥', nombre: 'En Racha Ranked',  desc: '3 victorias consecutivas ranked' },
          { n: 5,  emoji: '🌪️', nombre: 'Torbellino',       desc: '5 victorias consecutivas ranked' },
          { n: 10, emoji: '☄️', nombre: 'Meteoro',           desc: '10 victorias consecutivas ranked' },
        ];
        for (const h of hitosRacha) {
          if (racha >= h.n) {
            const { count } = await supabase.from('medallas_usuario').select('id', { count: 'exact', head: true }).eq('user_id', p.id).eq('nombre', h.nombre);
            if (!count) {
              await supabase.from('medallas_usuario').insert({ user_id: p.id, tipo: 'hito', subtipo: 'ranked', emoji: h.emoji, nombre: h.nombre, descripcion: h.desc, visible: true });
              await supabase.from('notificaciones').insert({ user_id: p.id, tipo: 'medalla', texto: `🏅 Nuevo hito: ${h.nombre}`, emoji: h.emoji, leida: false });
            }
          }
        }

        // Hitos por rango alcanzado
        const hitosRango = [
          { rango: 'Veterano', emoji: '⚪', nombre: 'Primera Liga',   desc: 'Alcanzaste rango Veterano' },
          { rango: 'Elite',    emoji: '🔵', nombre: 'Élite Ranked',   desc: 'Alcanzaste rango Élite' },
          { rango: 'Maestro',  emoji: '🟣', nombre: 'Maestro',        desc: 'Alcanzaste rango Maestro' },
          { rango: 'Leyenda',  emoji: '🔴', nombre: 'Leyenda',        desc: 'Alcanzaste rango Leyenda' },
          { rango: 'DTXI',     emoji: '👑', nombre: 'DTXI',           desc: 'El techo del juego — rango DTXI' },
        ];
        for (const h of hitosRango) {
          if (rango === h.rango) {
            const { count } = await supabase.from('medallas_usuario').select('id', { count: 'exact', head: true }).eq('user_id', p.id).eq('nombre', h.nombre);
            if (!count) {
              await supabase.from('medallas_usuario').insert({ user_id: p.id, tipo: 'hito', subtipo: 'ranked', emoji: h.emoji, nombre: h.nombre, descripcion: h.desc, visible: true });
              await supabase.from('notificaciones').insert({ user_id: p.id, tipo: 'medalla', texto: `🏅 Nuevo hito: ${h.nombre}`, emoji: h.emoji, leida: false });
            }
          }
        }
      }

      setRankedLog({ ok: true, msg: '✓ ' + data });
    } catch(err) { setRankedLog({ ok: false, msg: err.message }); }
    setResolviendoRanked(false);
  };

  // ── Jugadas Preparadas ────────────────────────────────────────────────────
  const JUGADAS = [
    {
      key: 'capitan_20pts_x3',
      emoji: '🎩', nombre: 'El Capitán Manda',
      desc: 'Tu capitán sumó +20 pts en 3 fechas distintas',
      check: async (userId) => {
        const { data } = await supabase
          .from('drafts')
          .select('equipo, capitan_index, puntos_por_jugador')
          .eq('user_id', userId)
          .not('capitan_index', 'is', null);
        if (!data) return false;
        let count = 0;
        for (const d of data) {
          const capIdx = d.capitan_index;
          const jugador = d.equipo?.[capIdx];
          if (!jugador) continue;
          const pts = d.puntos_por_jugador?.[jugador.id];
          if (pts && pts >= 20) count++;
        }
        return count >= 3;
      },
    },
    {
      key: '99pts_x5',
      emoji: '💯', nombre: 'Más de 99',
      desc: 'Superaste 99 pts en una fecha 5 veces',
      check: async (userId) => {
        const { count } = await supabase
          .from('torneo_puntos')
          .select('id', { count: 'exact', head: true })
          .eq('user_id', userId)
          .gte('puntos', 99);
        return (count || 0) >= 5;
      },
    },
    {
      key: 'comodin_en_contra',
      emoji: '🌩️', nombre: 'A Pesar de Todo',
      desc: 'Ganaste una fecha con un comodín en contra activo',
      check: async (userId, jornada) => {
        // Detectar si el usuario ganó esta jornada y tenía comodín en contra
        const { data: efectos } = await supabase
          .from('efectos_comodines')
          .select('tipo')
          .eq('user_id', userId)
          .eq('jornada', jornada)
          .eq('activo', true);
        if (!efectos?.some(e => e.tipo === 'contra')) return false;
        // Verificar si ganó alguna fecha de esta jornada
        const { data: puntos } = await supabase
          .from('torneo_puntos')
          .select('puntos, fecha_id, fecha:torneo_fechas(numero_fecha)')
          .eq('user_id', userId)
          .eq('fecha:torneo_fechas.numero_fecha', jornada);
        for (const pt of (puntos || [])) {
          const { data: otros } = await supabase
            .from('torneo_puntos')
            .select('puntos')
            .eq('fecha_id', pt.fecha_id)
            .neq('user_id', userId)
            .gt('puntos', pt.puntos);
          if (!otros?.length) return true; // nadie lo superó → ganó
        }
        return false;
      },
    },
    {
      key: 'presupuesto_minimo',
      emoji: '', nombre: 'Menos es Más',
      desc: 'Ganaste una fecha habiendo sorteado el presupuesto mínimo (40M)',
      check: async (userId, jornada) => {
        const { data: drafts } = await supabase
          .from('drafts')
          .select('presupuesto, jornada')
          .eq('user_id', userId)
          .eq('jornada', jornada)
          .lte('presupuesto', 40000000);
        if (!drafts?.length) return false;
        // Verificar si ganó la fecha
        const { data: puntos } = await supabase
          .from('torneo_puntos')
          .select('puntos, fecha_id')
          .eq('user_id', userId);
        for (const pt of (puntos || [])) {
          const { data: otros } = await supabase
            .from('torneo_puntos').select('puntos')
            .eq('fecha_id', pt.fecha_id).neq('user_id', userId).gt('puntos', pt.puntos);
          if (!otros?.length && pt.puntos > 0) return true;
        }
        return false;
      },
    },
    {
      key: 'racha_3_fechas_torneo',
      emoji: '🪬', nombre: 'Racha Imparable',
      desc: 'Ganaste 3 fechas seguidas dentro de un mismo torneo',
      check: async (userId) => {
        const { data: torneos } = await supabase
          .from('torneos').select('id');
        for (const t of (torneos || [])) {
          const { data: fechas } = await supabase
            .from('torneo_fechas').select('id, numero_fecha')
            .eq('torneo_id', t.id).order('numero_fecha', { ascending: true });
          let racha = 0;
          for (const f of (fechas || [])) {
            const { data: pts } = await supabase
              .from('torneo_puntos').select('puntos')
              .eq('fecha_id', f.id).eq('user_id', userId).single();
            if (!pts) { racha = 0; continue; }
            const { data: otros } = await supabase
              .from('torneo_puntos').select('puntos')
              .eq('fecha_id', f.id).neq('user_id', userId).gt('puntos', pts.puntos);
            if (!otros?.length && pts.puntos > 0) { racha++; if (racha >= 3) return true; }
            else racha = 0;
          }
        }
        return false;
      },
    },
    {
      key: 'ultimo_en_confirmar',
      emoji: '🌑', nombre: 'Al Filo',
      desc: 'Ganaste una fecha siendo el último en confirmar equipo',
      check: async (userId, jornada) => {
        // Ver si fue el último en confirmar esta jornada
        const { data: drafts } = await supabase
          .from('drafts').select('confirmado_at, user_id')
          .eq('jornada', jornada).eq('confirmado', true)
          .order('confirmado_at', { ascending: false });
        if (!drafts?.length || drafts[0].user_id !== userId) return false;
        // Verificar si ganó alguna fecha
        const { data: puntos } = await supabase
          .from('torneo_puntos').select('puntos, fecha_id')
          .eq('user_id', userId);
        for (const pt of (puntos || [])) {
          const { data: otros } = await supabase
            .from('torneo_puntos').select('puntos')
            .eq('fecha_id', pt.fecha_id).neq('user_id', userId).gt('puntos', pt.puntos);
          if (!otros?.length && pt.puntos > 0) return true;
        }
        return false;
      },
    },
    {
      key: 'todas_las_formaciones',
      emoji: '🗺️', nombre: 'Enciclopedia Táctica',
      desc: 'Ganaste al menos una fecha con cada una de las 9 formaciones',
      check: async (userId) => {
        const FORMACIONES = ['4-3-3','4-4-2','3-5-2','5-3-2','3-4-3','4-5-1','5-2-3','4-2-4','3-3-4'];
        // Usa la función SQL optimizada — una sola query
        const { data } = await supabase.rpc('check_enciclopedia_tactica', {
          p_formaciones: FORMACIONES,
        });
        return (data || []).some(row => row.user_id === userId);
      },
    },
  ];

  const detectarJugadasPreparadas = async (jornada) => {
    // Traer todos los user_ids activos
    const { data: perfiles } = await supabase.from('perfiles').select('id');
    if (!perfiles?.length) return;

    for (const { id: userId } of perfiles) {
      for (const jugada of JUGADAS) {
        // Verificar si ya la tiene
        const { count } = await supabase
          .from('medallas_usuario')
          .select('id', { count: 'exact', head: true })
          .eq('user_id', userId)
          .eq('tipo', 'jugada_preparada')
          .eq('nombre', jugada.nombre);
        if (count > 0) continue; // ya la tiene

        // Evaluar condición
        let cumple = false;
        try { cumple = await jugada.check(userId, jornada); } catch(e) { continue; }
        if (!cumple) continue;

        // Otorgar medalla oculta
        await supabase.from('medallas_usuario').insert({
          user_id:     userId,
          tipo:        'jugada_preparada',
          subtipo:     jugada.key,
          emoji:       jugada.emoji,
          nombre:      jugada.nombre,
          descripcion: jugada.desc,
          visible:     false, // oculta hasta que el usuario la vea
        });

        // Notificar al usuario
        await supabase.from('notificaciones').insert({
          user_id: userId,
          tipo:    'jugada_preparada',
          texto:   `¡Desbloqueaste una Jugada Preparada! ${jugada.emoji}`,
          emoji:   '',
          leida:   false,
        });
      }
    }
    console.log('Jugadas Preparadas procesadas');
  };

  // ── Lógica de restricciones ───────────────────────────────────────────────
  // Parsea el texto de una restricción y devuelve los IDs de jugadores del equipo
  // que cumplen esa restricción (los que "aplican" para el cómputo de puntos)
  const obtenerJugadoresCumplen = (restriccionTexto, equipo, jornada) => {
    const texto = restriccionTexto.toLowerCase();
    const titulares = Object.entries(equipo)
      .filter(([slot]) => parseInt(slot) <= 10) // solo titulares (0-10)
      .map(([, j]) => j);
    const añoJornada = 2025; // año base del torneo

    // Helpers
    const edad = (j) => {
      if (!j.fecha_nacimiento) return 0;
      return añoJornada - new Date(j.fecha_nacimiento).getFullYear();
    };

    // ── Patrones de restricción ──────────────────────────────────────────────
    // "mínimo N zurdos" / "al menos N zurdos" → todos los zurdos del equipo
    if (texto.includes('zurdo')) {
      return titulares.filter(j => j.pie_habil === 'Izquierdo').map(j => j.id);
    }
    // "mínimo N diestros"
    if (texto.includes('diestro')) {
      return titulares.filter(j => j.pie_habil === 'Derecho').map(j => j.id);
    }
    // "+X años" / "mayor de X" / "con +X años"
    const matchEdad = texto.match(/\+(\d+)\s*a[ñn]/);
    if (matchEdad) {
      const limite = parseInt(matchEdad[1]);
      return titulares.filter(j => edad(j) > limite).map(j => j.id);
    }
    // "sub-X" / "menores de X" / "menos de X años"
    const matchSub = texto.match(/sub[-\s]?(\d+)|menor[es]* de (\d+)/);
    if (matchSub) {
      const limite = parseInt(matchSub[1] || matchSub[2]);
      return titulares.filter(j => edad(j) < limite).map(j => j.id);
    }
    // "+X.XXm" / "más de Xcm" → altura
    const matchAltura = texto.match(/\+?(\d+[.,]\d+)\s*m\b|(\d{3})\s*cm/);
    if (matchAltura) {
      const cm = matchAltura[1]
        ? Math.round(parseFloat(matchAltura[1].replace(',', '.')) * 100)
        : parseInt(matchAltura[2]);
      return titulares.filter(j => (j.altura || 0) >= cm).map(j => j.id);
    }
    // Definir sets de continentes con nombres exactos de la DB
    const SETS_CONTINENTES = {
      africano:      ['Marruecos','Senegal','Egipto','Ghana','Costa de Marfil','Túnez','Argelia','Sudáfrica','Cabo Verde','RD Congo','Nigeria','Camerún','Mali'],
      europeo:       ['España','Alemania','Francia','Portugal','Países Bajos','Bélgica','Croacia','Austria','Suiza','Escocia','Inglaterra','Noruega','Suecia','República Checa','Bosnia','Turquía','Italia','Dinamarca'],
      sudamericano:  ['Argentina','Brasil','Uruguay','Colombia','Ecuador','Venezuela','Paraguay','Chile','Perú','Bolivia'],
      asiatico:      ['Japón','Corea del Sur','Irán','Arabia Saudita','Qatar','Uzbekistán','Jordania','Irak'],
      concacaf:      ['México','USA','Canadá','Panamá','Haití','Curazao'],
    };

    // Detectar combinación posición + continente (ej: "defensor africano", "mínimo 1 defensor africano")
    const POSICIONES_TEXTO = { 'arquero': 'ARQ', 'defensor': 'DEF', 'volante': 'VOL', 'delantero': 'DEL' };
    let posFiltro = null;
    for (const [key, sigla] of Object.entries(POSICIONES_TEXTO)) {
      if (texto.includes(key)) { posFiltro = sigla; break; }
    }

    for (const [continente, paises] of Object.entries(SETS_CONTINENTES)) {
      if (texto.includes(continente) || (continente === 'asiatico' && texto.includes('asiático'))) {
        const paisesSet = new Set(paises);
        if (posFiltro) {
          // Combinación posición + continente
          return titulares.filter(j => j.posicion?.sigla === posFiltro && paisesSet.has(j.nacionalidad)).map(j => j.id);
        }
        return titulares.filter(j => paisesSet.has(j.nacionalidad)).map(j => j.id);
      }
    }
    // Posición sola (sin continente — si ya se procesó combinado, no llega acá)
    if (!posFiltro) {
      for (const [key, sigla] of Object.entries(POSICIONES_TEXTO)) {
        if (texto.includes(key)) {
          return titulares.filter(j => j.posicion?.sigla === sigla).map(j => j.id);
        }
      }
    } else if (posFiltro && !Object.keys(SETS_CONTINENTES).some(c => texto.includes(c) || (c === 'asiatico' && texto.includes('asiático')))) {
      return titulares.filter(j => j.posicion?.sigla === posFiltro).map(j => j.id);
    }
    // Precio: "máximo $XM" / "precio máx"
    const matchPrecio = texto.match(/máx[^\d]*\$?(\d+)[,.]?(\d+)?m/i);
    if (matchPrecio) {
      const maximo = parseFloat(`${matchPrecio[1]}.${matchPrecio[2] || '0'}`) * 1_000_000;
      return titulares.filter(j => (j.precio || 0) <= maximo).map(j => j.id);
    }

    // Ex ligas: "ex premier", "ex serie a", "ex la liga", "ex ligue 1", "ex bundesliga"
    const LIGAS_MAP = {
      'premier':    'Premier League',
      'serie a':    'Serie A',
      'la liga':    'La Liga',
      'ligue 1':    'Ligue 1',
      'bundesliga': 'Bundesliga',
    };
    for (const [key, liga] of Object.entries(LIGAS_MAP)) {
      if (texto.includes('ex') && texto.includes(key)) {
        return titulares.filter(j => j.ex_ligas?.includes(liga)).map(j => j.id);
      }
    }

    // Liga actual: "premier actual", "X jugadores premier"
    for (const [key, liga] of Object.entries(LIGAS_MAP)) {
      if (!texto.includes('ex') && texto.includes(key)) {
        return titulares.filter(j => j.liga_club === liga).map(j => j.id);
      }
    }

    // Campeones del mundo
    if (texto.includes('campeón del mundo') || texto.includes('campeones del mundo')) {
      const CAMP = new Set(['Argentina','Brasil','Uruguay','España','Francia','Inglaterra','Italia','Alemania']);
      return titulares.filter(j => CAMP.has(j.nacionalidad)).map(j => j.id);
    }

    // Finalistas Argentina + Francia (Mundial 2022)
    if (texto.includes('finalistas') && (texto.includes('argentina') || texto.includes('francia'))) {
      return titulares.filter(j => ['Argentina','Francia'].includes(j.nacionalidad)).map(j => j.id);
    }

    // Último campeón (Argentina)
    if (texto.includes('último campeón') || texto.includes('ultimo campeon')) {
      return titulares.filter(j => j.nacionalidad === 'Argentina').map(j => j.id);
    }

    // No se pudo parsear → devolver array vacío
    return [];
  };

  const procesarRestriccionesAportes = async (jornada) => {
    // Traer todos los drafts confirmados de esta jornada con restricciones
    const { data: drafts } = await supabase
      .from('drafts')
      .select('user_id, restricciones, equipo')
      .eq('jornada', jornada)
      .eq('confirmado', true);
    if (!drafts?.length) return;

    // Traer puntos de jugadores de esta jornada
    const { data: puntosJug } = await supabase
      .from('jugador_puntos_fecha')
      .select('jugador_id, puntos_total')
      .eq('jornada', jornada);
    const ptsPorJugador = {};
    (puntosJug || []).forEach(p => { ptsPorJugador[p.jugador_id] = p.puntos_total || 0; });

    for (const draft of drafts) {
      if (!draft.restricciones?.length || !draft.equipo) continue;
      let aportesEnEstaFecha = 0;

      for (const res of draft.restricciones) {
        if (res.anulada || !res.cumplida) continue;
        const jugadoresCumplen = obtenerJugadoresCumplen(res.texto, draft.equipo, jornada);
        if (!jugadoresCumplen.length) continue;

        // Restricción individual (1 jugador) → suma ≥10 pts
        // Restricción grupal (N jugadores) → promedio ≥8 pts
        let aportaEstaRes = false;
        if (jugadoresCumplen.length === 1) {
          const pts = ptsPorJugador[jugadoresCumplen[0]] || 0;
          aportaEstaRes = pts >= 10;
        } else {
          const suma = jugadoresCumplen.reduce((acc, id) => acc + (ptsPorJugador[id] || 0), 0);
          const promedio = suma / jugadoresCumplen.length;
          aportaEstaRes = promedio >= 8;
        }

        if (aportaEstaRes) aportesEnEstaFecha++;
      }

      // Contar restricciones cumplidas (para Sin Desperdicios / Comprometido)
      const cumplidas = (draft.restricciones || []).filter(r => r.cumplida && !r.anulada).length;
      if (cumplidas > 0) {
        // Insertar registros de restriccion_cumplida (invisibles, solo para contar)
        for (let i = 0; i < cumplidas; i++) {
          await supabase.from('medallas_usuario').insert({
            user_id: draft.user_id, tipo: 'restriccion_cumplida', subtipo: 'restriccion',
            emoji: '✅', nombre: 'Restricción cumplida', descripcion: `Jornada ${jornada}`, visible: false,
          });
        }
        const { count: totalCumplidas } = await supabase
          .from('medallas_usuario').select('id', { count: 'exact', head: true })
          .eq('user_id', draft.user_id).eq('tipo', 'restriccion_cumplida');
        const HITOS_CUM = [
          { n: 5,  subtipo: 'restricciones_5',  emoji: '5restricciones.png',  nombre: '5 Restricciones',  desc: 'Cumpliste 5 restricciones' },
          { n: 10, subtipo: 'restricciones_10', emoji: '10restricciones.png', nombre: '10 Restricciones', desc: 'Cumpliste 10 restricciones' },
          { n: 20, subtipo: 'restricciones_20', emoji: '20restricciones.png', nombre: '20 Restricciones', desc: 'Cumpliste 20 restricciones' },
          { n: 30, subtipo: 'restricciones_30', emoji: '30restricciones.png', nombre: '30 Restricciones', desc: 'Cumpliste 30 restricciones' },
          { n: 40, subtipo: 'restricciones_40', emoji: '40restricciones.png', nombre: '40 Restricciones', desc: 'Cumpliste 40 restricciones' },
        ];
        for (const h of HITOS_CUM) {
          const prev = (totalCumplidas || 0) - cumplidas;
          if ((totalCumplidas || 0) >= h.n && prev < h.n) {
            const { count } = await supabase.from('medallas_usuario').select('id', { count: 'exact', head: true }).eq('user_id', draft.user_id).eq('subtipo', h.subtipo);
            if (!count) {
              await supabase.from('medallas_usuario').insert({ user_id: draft.user_id, tipo: 'hito', subtipo: h.subtipo, emoji: h.emoji, nombre: h.nombre, descripcion: h.desc, visible: true });
              await supabase.from('notificaciones').insert({ user_id: draft.user_id, tipo: 'medalla', texto: `🏅 Nuevo hito: ${h.nombre}`, emoji: h.emoji, leida: false });
            }
          }
        }
      }

      if (!aportesEnEstaFecha) continue;

      // Registrar aportes en medallas_usuario (uno por aporte)
      for (let i = 0; i < aportesEnEstaFecha; i++) {
        await supabase.from('medallas_usuario').insert({
          user_id: draft.user_id, tipo: 'restriccion_aporte', subtipo: 'restriccion',
          emoji: '', nombre: 'Aporte de restricción',
          descripcion: `Jornada ${jornada}`, visible: false,
        });
      }

      // Contar total acumulado y verificar hitos
      const { count: totalAportes } = await supabase
        .from('medallas_usuario')
        .select('id', { count: 'exact', head: true })
        .eq('user_id', draft.user_id)
        .eq('tipo', 'restriccion_aporte');

      // Victorias globales (táctico + libre) — se verifican al ganar una fecha
      const { count: totalVictorias } = await supabase.from('medallas_usuario')
        .select('id', { count: 'exact', head: true })
        .eq('user_id', draft.user_id).eq('tipo', 'fecha_torneo');
      const HITOS_VICTORIAS = [
        { n: 5,  subtipo: 'victorias_5',  emoji: '5victoriag.png',  nombre: '5 Victorias',  desc: 'Ganaste 5 fechas en total' },
        { n: 10, subtipo: 'victorias_10', emoji: '10victoriag.png', nombre: '10 Victorias', desc: 'Ganaste 10 fechas en total' },
        { n: 20, subtipo: 'victorias_20', emoji: '20victoriag.png', nombre: '20 Victorias', desc: 'Ganaste 20 fechas en total' },
        { n: 30, subtipo: 'victorias_30', emoji: '30victoriag.png', nombre: '30 Victorias', desc: 'Ganaste 30 fechas en total' },
        { n: 40, subtipo: 'victorias_40', emoji: '40victoriag.png', nombre: '40 Victorias', desc: 'Ganaste 40 fechas en total' },
      ];
      const HITOS_RES = []; // legacy — ya no se usan
      for (const h of HITOS_RES) {
        const prevTotal = (totalAportes || 0) - aportesEnEstaFecha;
        if ((totalAportes || 0) >= h.n && prevTotal < h.n) {
          const { count } = await supabase.from('medallas_usuario').select('id', { count: 'exact', head: true }).eq('user_id', draft.user_id).eq('nombre', h.nombre);
          if (!count) {
            await supabase.from('medallas_usuario').insert({ user_id: draft.user_id, tipo: 'hito', subtipo: 'restriccion', emoji: h.emoji, nombre: h.nombre, descripcion: h.desc, visible: true });
            await supabase.from('notificaciones').insert({ user_id: draft.user_id, tipo: 'medalla', texto: `🏅 Nuevo hito: ${h.nombre}`, emoji: h.emoji, leida: false });
          }
        }
      }
    }
    console.log('Aportes de restricciones procesados');
  };

  const distribuirPuntosLibre = async () => {
    setDistribuyendoLibre(true);
    setDistribucionLog(null);
    try {
      const { data: puntosJug } = await supabase.from('jugador_puntos_fecha')
        .select('jugador_id, puntos_base, puntos_bonus, puntos_total').eq('jornada', jornadaTorneo);
      if (!puntosJug?.length) {
        setDistribucionLog({ ok: false, msg: `No hay puntos cargados para jornada ${jornadaTorneo}.` });
        setDistribuyendoLibre(false); return;
      }
      const mapaPuntos = {};
      puntosJug.forEach(p => { mapaPuntos[p.jugador_id] = { base: p.puntos_base ?? p.puntos_total, bonus: p.puntos_bonus ?? 0, total: p.puntos_total }; });

      // Solo torneos libres
      const { data: torneos } = await supabase.from('torneos').select('id, nombre, tipo').eq('tipo', 'libre');
      const { data: fechasTorneo } = await supabase.from('torneo_fechas').select('id, torneo_id, numero_fecha').eq('numero_fecha', jornadaTorneo);
      if (!fechasTorneo?.length) { setDistribucionLog({ ok: false, msg: `No existe fecha ${jornadaTorneo} en torneos.` }); setDistribuyendoLibre(false); return; }

      // Drafts libres: jornada actual confirmada tiene prioridad, fallback jornada 0
      // Para jornada 1, usar jornada 0 como base y solo pisar si jornada 1 tiene equipo_libre con datos
      const { data: draftsLibreActual } = await supabase.from('drafts').select('user_id, equipo_libre, capitan_index_libre, confirmado').eq('jornada', jornadaTorneo).eq('confirmado', true);
      const { data: draftsLibreLegacy } = await supabase.from('drafts').select('user_id, equipo_libre, capitan_index_libre, confirmado').eq('jornada', 0).eq('confirmado', true);
      const draftsLibreMap = {};
      (draftsLibreLegacy || []).forEach(d => { if (d.equipo_libre && Object.keys(d.equipo_libre).length > 0) draftsLibreMap[d.user_id] = d; });
      // Solo pisar con jornada actual si tiene más jugadores que el legacy (evita pisar con equipo vacío)
      (draftsLibreActual || []).forEach(d => {
        const legacyKeys = Object.keys(draftsLibreMap[d.user_id]?.equipo_libre || {}).length;
        const actualKeys = Object.keys(d.equipo_libre || {}).length;
        if (d.equipo_libre && actualKeys >= legacyKeys && actualKeys > 0) draftsLibreMap[d.user_id] = d;
      });

      const { data: participantes } = await supabase.from('torneo_participantes').select('user_id, torneo_id');
      const POS_SUPLENTE = { 20: 'ARQ', 21: 'DEF', 22: 'VOL', 23: 'DEL' };
      const SLOTS_TITULARES = [0,1,2,3,4,5,6,7,8,9,10];
      let totalUpserts = 0; const errores = [];

      for (const fecha of fechasTorneo) {
        const torneo = torneos?.find(t => t.id === fecha.torneo_id);
        if (!torneo) continue;
        const participantesTorneo = participantes?.filter(p => p.torneo_id === torneo.id) || [];
        for (const part of participantesTorneo) {
          const dl = draftsLibreMap[part.user_id];
          const equipo = dl?.equipo_libre || {};
          const capitanIndex = dl?.capitan_index_libre ?? null;
          if (!Object.keys(equipo).length) continue;

          const puntajeJugador = {};
          let totalPuntos = 0;
          Object.entries(equipo).forEach(([slot, jug]) => {
            if (!jug?.id) return;
            const slotNum = Number(slot);
            const esSuplente = slotNum >= 20;
            if (esSuplente) {
              const posSuplente = POS_SUPLENTE[slotNum];
              const titularConPuntos = SLOTS_TITULARES.some(s => {
                const t = equipo[String(s)];
                const posTitular = t?.posicion?.sigla || t?.posicion;
                return t?.id && posTitular === posSuplente && mapaPuntos[t.id] != null;
              });
              if (titularConPuntos) return;
            }
            const pts = mapaPuntos[jug.id];
            if (pts == null) return;
            const esCapitan = slotNum === capitanIndex;
            const ptsFinales = esCapitan ? (pts.base * 2 + pts.bonus) : pts.total;
            puntajeJugador[jug.id] = ptsFinales;
            totalPuntos += ptsFinales;
          });

          const { error } = await supabase.from('torneo_puntos').upsert({
            torneo_id: torneo.id, fecha_id: fecha.id, user_id: part.user_id,
            puntos: totalPuntos, puntos_por_jugador: puntajeJugador,
            equipo: equipo, capitan_index: capitanIndex,
          }, { onConflict: 'torneo_id,fecha_id,user_id' });
          if (error) errores.push(error.message); else totalUpserts++;
        }
      }
      setDistribucionLog({ ok: errores.length === 0, msg: errores.length === 0 ? `✓ Libre distribuido: ${totalUpserts} equipos procesados.` : `${totalUpserts} ok, errores: ${errores.join(', ')}` });
    } catch(e) { setDistribucionLog({ ok: false, msg: e.message }); }
    setDistribuyendoLibre(false);
  };

  const distribuirPuntos = async () => {
    setDistribuyendo(true);
    setDistribucionLog(null);
    try {
      // 1. Traer puntos globales de jugador_puntos_fecha para esta jornada del torneo
      const { data: puntosJug } = await supabase
        .from('jugador_puntos_fecha')
        .select('jugador_id, puntos_base, puntos_bonus, puntos_total')
        .eq('jornada', jornadaTorneo);

      if (!puntosJug?.length) {
        setDistribucionLog({ ok: false, msg: `No hay puntos cargados en jugador_puntos_fecha para jornada ${jornadaTorneo}. Cargá los puntos primero desde el fixture.` });
        setDistribuyendo(false);
        return;
      }

      // Mapa jugador_id → { base, bonus, total }
      const mapaPuntos = {};
      puntosJug.forEach(p => { mapaPuntos[p.jugador_id] = { base: p.puntos_base ?? p.puntos_total, bonus: p.puntos_bonus ?? 0, total: p.puntos_total }; });

      // 2. Traer todos los torneos activos con sus fechas
      const { data: torneos } = await supabase
        .from('torneos').select('id, nombre, tipo');

      const { data: fechasTorneo } = await supabase
        .from('torneo_fechas')
        .select('id, torneo_id, numero_fecha')
        .eq('numero_fecha', jornadaTorneo);

      if (!fechasTorneo?.length) {
        setDistribucionLog({ ok: false, msg: `No existe fecha ${jornadaTorneo} en los torneos. Creá las fechas desde AdminTorneo primero.` });
        setDistribuyendo(false);
        return;
      }

      // 3. Traer todos los drafts confirmados de esta jornada (táctico)
      const { data: drafts } = await supabase
        .from('drafts')
        .select('user_id, jornada, equipo, capitan_index, confirmado')
        .eq('jornada', jornadaTorneo)
        .eq('confirmado', true);

      // 4. Traer drafts del modo libre — primero jornada actual, fallback jornada 0
      const { data: draftsLibreActual } = await supabase
        .from('drafts')
        .select('user_id, equipo_libre, capitan_index_libre, confirmado')
        .eq('jornada', jornadaTorneo)
        .eq('confirmado', true);
      const { data: draftsLibreLegacy } = await supabase
        .from('drafts')
        .select('user_id, equipo_libre, capitan_index_libre, confirmado')
        .eq('jornada', 0)
        .eq('confirmado', true);
      // Combinar: jornada actual tiene prioridad sobre legacy
      const draftsLibreMap = {};
      (draftsLibreLegacy || []).forEach(d => { if (d.equipo_libre) draftsLibreMap[d.user_id] = d; });
      (draftsLibreActual || []).forEach(d => { if (d.equipo_libre) draftsLibreMap[d.user_id] = d; });
      const draftsLibre = Object.values(draftsLibreMap);

      // 5. Traer participantes de cada torneo
      const { data: participantes } = await supabase
        .from('torneo_participantes')
        .select('user_id, torneo_id');

      let totalUpserts = 0;
      const errores = [];

      // 6. Para cada torneo × fecha × participante → calcular y guardar
      for (const fecha of fechasTorneo) {
        const torneo = torneos?.find(t => t.id === fecha.torneo_id);
        if (!torneo) continue;

        const esLibre = torneo.tipo === 'libre';
        const participantesTorneo = participantes?.filter(p => p.torneo_id === torneo.id) || [];

        for (const part of participantesTorneo) {
          // Elegir el equipo correcto según tipo de torneo
          let equipo = {};
          let capitanIndex = null;
          let draft = null;

          if (esLibre) {
            const dl = draftsLibre?.find(d => d.user_id === part.user_id);
            equipo = dl?.equipo_libre || {};
            capitanIndex = dl?.capitan_index_libre ?? null;
            draft = dl;
          } else {
            const dt = drafts?.find(d => d.user_id === part.user_id);
            if (!dt) continue; // no confirmó equipo táctico esta jornada
            equipo = dt.equipo || {};
            capitanIndex = dt.capitan_index ?? null;
            draft = dt;
          }

          // Calcular puntos por jugador
          const puntajeJugador = {};
          let totalPuntos = 0;

          // Mapeo de suplentes a posición titular que reemplaza:
          // slot 20 = ARQ (slot 0), slot 21 = DEF, slot 22 = VOL, slot 23 = DEL
          const POS_SUPLENTE = { 20: 'ARQ', 21: 'DEF', 22: 'VOL', 23: 'DEL' };
          const SLOTS_TITULARES = [0,1,2,3,4,5,6,7,8,9,10];

          // Ver qué posiciones titulares NO sumaron (jugador sin puntos cargados)
          const posicionesSinPuntos = new Set();
          SLOTS_TITULARES.forEach(s => {
            const jug = equipo[String(s)];
            if (!jug?.id) return;
            const pts = mapaPuntos[jug.id];
            // Si no tiene puntos cargados, su posición queda libre para el suplente
            if (pts == null) posicionesSinPuntos.add(jug.posicion?.sigla || jug.posicion);
          });

          Object.entries(equipo).forEach(([slot, jug]) => {
            if (!jug?.id) return;
            const slotNum = Number(slot);
            const esSuplente = slotNum >= 20;

            // Suplente: entra solo si NO todos los titulares de su posición sumaron
            if (esSuplente) {
              const posSuplente = POS_SUPLENTE[slotNum];
              const titularesDePos = SLOTS_TITULARES.filter(s => {
                const t = equipo[String(s)];
                const posTitular = t?.posicion?.sigla || t?.posicion;
                return t?.id && posTitular === posSuplente;
              });
              const titularesConPuntos = titularesDePos.filter(s => {
                const t = equipo[String(s)];
                return t?.id && mapaPuntos[t.id] != null;
              }).length;
              // Solo NO entra si TODOS los titulares de su pos sumaron
              if (titularesConPuntos >= titularesDePos.length) return;
            }

            const pts = mapaPuntos[jug.id];
            if (pts == null) return;

            const esCapitan = slotNum === capitanIndex;
            // ⚠️ Capitán duplica SOLO puntos_base, el bonus NO se duplica
            const ptsFinales = esCapitan ? (pts.base * 2 + pts.bonus) : pts.total;

            puntajeJugador[jug.id] = ptsFinales;
            totalPuntos += ptsFinales;
          });

          // Upsert en torneo_puntos
          const { error } = await supabase.from('torneo_puntos').upsert({
            torneo_id: torneo.id,
            fecha_id: fecha.id,
            user_id: part.user_id,
            puntos: totalPuntos,
            puntos_por_jugador: puntajeJugador,
            equipo: equipo,
            formacion: draft?.formacion || null,
            restricciones: draft?.restricciones || [],
            capitan_index: capitanIndex,
          }, { onConflict: 'torneo_id,fecha_id,user_id' });

          if (error) errores.push(`${part.user_id.slice(0,8)}: ${error.message}`);
          else totalUpserts++;
        }
      }

      if (errores.length > 0) {
        setDistribucionLog({ ok: false, msg: `${totalUpserts} OK, ${errores.length} errores: ${errores.join(' | ')}` });
      } else {
        // ⚠️ NO BORRAR: cerrar fecha actual y activar la siguiente en todos los torneos
        try {
          const { data: fechasActivas } = await supabase
            .from('torneo_fechas').select('id, torneo_id, numero_fecha')
            .eq('numero_fecha', jornadaTorneo).eq('activa', true);
          for (const fecha of (fechasActivas || [])) {
            await supabase.from('torneo_fechas').update({ activa: false }).eq('id', fecha.id);
            const { data: proxFecha } = await supabase.from('torneo_fechas')
              .select('id').eq('torneo_id', fecha.torneo_id).eq('numero_fecha', jornadaTorneo + 1).maybeSingle();
            if (proxFecha) {
              await supabase.from('torneo_fechas').update({ activa: true }).eq('id', proxFecha.id);
            } else {
              // ⚠️ No hay fecha siguiente → torneo terminado → otorgar medallas de ranking
              try {
                const { data: rankingFinal } = await supabase
                  .from('torneo_participantes')
                  .select('user_id, puntos_totales, torneo:torneos(nombre, tipo)')
                  .eq('torneo_id', fecha.torneo_id)
                  .order('puntos_totales', { ascending: false });

                if (rankingFinal?.length) {
                  const tipo = rankingFinal[0]?.torneo?.tipo || 'tactico';
                  const nombre = rankingFinal[0]?.torneo?.nombre || 'Torneo';
                  const MEDALLAS_RANKING = [
                    { pos: 0, emoji: '🥇', nombre: `Campeón ${tipo === 'tactico' ? 'Táctico' : 'Libre'}` },
                    { pos: 1, emoji: '🥈', nombre: `Subcampeón ${tipo === 'tactico' ? 'Táctico' : 'Libre'}` },
                    { pos: 2, emoji: '🥉', nombre: `Top 3 ${tipo === 'tactico' ? 'Táctico' : 'Libre'}` },
                  ];
                  for (const m of MEDALLAS_RANKING) {
                    const jugador = rankingFinal[m.pos];
                    if (!jugador || !jugador.puntos_totales) continue;
                    await supabase.from('medallas_usuario').insert({
                      user_id: jugador.user_id, tipo: 'ranking_top', subtipo: tipo,
                      emoji: m.emoji, nombre: m.nombre,
                      descripcion: `${m.nombre} en ${nombre}`,
                      torneo_nombre: nombre, visible: true,
                    });
                    await supabase.from('notificaciones').insert({
                      user_id: jugador.user_id, tipo: 'medalla',
                      texto: `🏅 Nuevo hito: ${m.nombre}`, emoji: m.emoji, leida: false,
                    });
                  }
                  // Top 10
                  const top10 = rankingFinal.slice(3, 10);
                  for (const jugador of top10) {
                    if (!jugador.puntos_totales) continue;
                    await supabase.from('medallas_usuario').insert({
                      user_id: jugador.user_id, tipo: 'ranking_top', subtipo: tipo,
                      emoji: '🏅', nombre: `Top 10 ${tipo === 'tactico' ? 'Táctico' : 'Libre'}`,
                      descripcion: `Top 10 en ${nombre}`, torneo_nombre: nombre, visible: true,
                    });
                  }
                }
              } catch(e) { console.error('Error medallas ranking:', e); }
            }
          }
        } catch(e) { console.error('Error cerrando fecha:', e); }

        // ⚠️ Resolver guerras de clanes automáticamente después de distribuir puntos
        try {
          const { data: guerrasLog, error: guerrasErr } = await supabase.rpc('resolver_guerras_jornada', { p_jornada: jornadaTorneo });
          if (guerrasErr) console.error('Error resolviendo guerras:', guerrasErr);
          else if (guerrasLog) console.log('Guerras:', guerrasLog);
        } catch(e) { console.error('Error guerras:', e); }

        const registrarFormacionGanada = async (userId, formacion) => {
  const TODAS_FORMACIONES = ['4-3-3','4-4-2','3-5-2','5-3-2','3-4-3','4-5-1','5-2-3','4-2-4','3-3-4'];

  // 1. Traer formaciones_ganadas actuales del perfil
  const { data: perfil } = await supabase
    .from('perfiles')
    .select('formaciones_ganadas')
    .eq('id', userId)
    .single();

  const actuales = perfil?.formaciones_ganadas || [];

  // 2. Si esta formación ya está registrada, no hacer nada
  if (actuales.includes(formacion)) return;

  // 3. Agregar la nueva formación
  const nuevas = [...actuales, formacion];
  await supabase
    .from('perfiles')
    .update({ formaciones_ganadas: nuevas })
    .eq('id', userId);

  // 4. Verificar si completó las 9 formaciones
  const tieneTodasLas9 = TODAS_FORMACIONES.every(f => nuevas.includes(f));
  if (!tieneTodasLas9) return;

  // 5. Verificar que no tenga ya la medalla
  const { count } = await supabase
    .from('medallas_usuario')
    .select('id', { count: 'exact', head: true })
    .eq('user_id', userId)
    .eq('subtipo', 'jp_enciclopedia');

  if (count > 0) return;

  // 6. Otorgar la medalla jugada preparada
  await supabase.from('medallas_usuario').insert({
    user_id:     userId,
    tipo:        'jugada_preparada',
    subtipo:     'jp_enciclopedia',
    emoji:       'enciclopediatactica.png',
    nombre:      'Enciclopedia Táctica',
    descripcion: 'Ganaste al menos una fecha con cada una de las 9 formaciones',
    visible:     false,
  });

  // 7. Notificar
  await supabase.from('notificaciones').insert({
    user_id: userId,
    tipo:    'jugada_preparada',
    texto:   '¡Desbloqueaste una Jugada Preparada! ',
    emoji:   '',
    leida:   false,
  });
};

        // ⚠️ Otorgar medallas al ganador de cada fecha de torneo táctico/libre
        try {
          // Traer todos los torneos con info completa
          const { data: todosLosTorneos } = await supabase
            .from('torneos').select('id, nombre, tipo, clan_id');
          const infoTorneo = {};
          (todosLosTorneos || []).forEach(t => { infoTorneo[t.id] = t; });

          // Traer puntos de esta jornada con join a torneo_fechas
          const { data: fechasJornada } = await supabase
            .from('torneo_fechas')
            .select('id, torneo_id, numero_fecha')
            .eq('numero_fecha', jornadaTorneo);

          for (const fecha of (fechasJornada || [])) {
            const torneo = infoTorneo[fecha.torneo_id];
            if (!torneo) continue;

            const { data: ptsEnFecha } = await supabase
              .from('torneo_puntos')
              .select('user_id, puntos, presupuesto_gastado')
              .eq('fecha_id', fecha.id);

            if (!ptsEnFecha?.length) continue;

            // Tier por cantidad de participantes
            const n = ptsEnFecha.length;
            if (n < 5) continue; // mínimo 5 participantes
            // Tier por modo: subtipo = tactico_bronce | tactico_plata | tactico_oro | tactico_diamante | tactico_legendaria
            // idem libre_xxx y prode_xxx
            const modo = torneo.tipo; // 'tactico' | 'libre' | 'prode'
            const emojiBase = modo === 'prode' ? 'prode' : '';
            const tierDef = n >= 50 ? { nivel: 'legendaria', emoji: emojiBase ? 'prodelegendario.png' : 'legendaria.png', nombre: `Legendaria ${modo === 'tactico' ? 'Táctica' : modo === 'libre' ? 'Libre' : 'Prode'}` }
                          : n >= 25 ? { nivel: 'diamante',   emoji: emojiBase ? 'prodediamante.png'   : 'diamante.png',   nombre: `Diamante ${modo === 'tactico' ? 'Táctico' : modo === 'libre' ? 'Libre' : 'Prode'}` }
                          : n >= 15 ? { nivel: 'oro',        emoji: emojiBase ? 'prodeoro.png'        : 'oro.png',        nombre: `Oro ${modo === 'tactico' ? 'Táctico' : modo === 'libre' ? 'Libre' : 'Prode'}` }
                          : n >= 10 ? { nivel: 'plata',      emoji: emojiBase ? 'prodeplata.png'      : 'plata.png',      nombre: `Plata ${modo === 'tactico' ? 'Táctica' : modo === 'libre' ? 'Libre' : 'Prode'}` }
                          :           { nivel: 'bronce',     emoji: emojiBase ? 'prodebronce.png'     : 'bronce.png',     nombre: `Bronce ${modo === 'tactico' ? 'Táctico' : modo === 'libre' ? 'Libre' : 'Prode'}` };
            const subtipo_fecha = `${modo}_${tierDef.nivel}`;
            const tier = { ...tierDef, desc: `Ganaste una fecha con ${n} participantes` };

            // Ganador de la fecha
            const ganador = ptsEnFecha.reduce((acc, pt) => {
              if (!acc) return pt;
              if (pt.puntos > acc.puntos) return pt;
              if (pt.puntos === acc.puntos && (pt.presupuesto_gastado||0) < (acc.presupuesto_gastado||0)) return pt;
              return acc;
            }, null);
            if (!ganador || ganador.puntos <= 0) continue;

            if (torneo.tipo === 'tactico') {
  // Buscar la formación del ganador en esta jornada
  const draftGanador = drafts?.find(d => d.user_id === ganador.user_id);
  if (draftGanador?.formacion) {
    try {
      await registrarFormacionGanada(ganador.user_id, draftGanador.formacion);
    } catch(e) { console.error('Error registrando formación ganada:', e); }
  }
}


            // Insertar medalla individual en medallas_usuario
            // Verificar si ya tiene esta medalla (evitar duplicados por mismo nivel en mismo torneo)
            const { count: yaExiste } = await supabase.from('medallas_usuario')
              .select('id', { count: 'exact', head: true })
              .eq('user_id', ganador.user_id).eq('subtipo', subtipo_fecha).eq('torneo_id', torneo.id).eq('numero_fecha', jornadaTorneo);
            if (!yaExiste) {
              await supabase.from('medallas_usuario').insert({
                user_id:      ganador.user_id,
                tipo:         'fecha_torneo',
                subtipo:      subtipo_fecha,
                emoji:        tier.emoji,
                nombre:       tier.nombre,
                descripcion:  tier.desc,
                torneo_id:    torneo.id,
                torneo_nombre: torneo.nombre,
                numero_fecha: jornadaTorneo,
                participantes: n,
              });
              await supabase.from('notificaciones').insert({
                user_id: ganador.user_id, tipo: 'medalla',
                texto: `🏅 ¡Ganaste la fecha! ${tier.nombre}`, emoji: tier.emoji, leida: false,
              });
            }

            // Si es torneo de clan, también sumar en clan_miembros
            if (torneo.clan_id) {
              await supabase.rpc('otorgar_medalla_fecha', {
                p_user_id: ganador.user_id,
                p_clan_id: torneo.clan_id,
              });
            }

            // Actualizar stats de perfil: fechas_ganadas y fechas_ganadas_[tipo]
            const campoModo = `fechas_ganadas_${torneo.tipo}`;
            await supabase.rpc('incrementar_fechas_ganadas', {
              p_user_id: ganador.user_id,
              p_campo: campoModo,
            });

            // Hitos individuales: verificar si alcanzó 1, 5, 10 fechas ganadas
            const { count: totalFechasGanadas } = await supabase
              .from('medallas_usuario')
              .select('id', { count: 'exact', head: true })
              .eq('user_id', ganador.user_id)
              .eq('tipo', 'fecha_torneo');

            // Hitos de fechas ganadas por modo (táctico / libre)
            const campoFechasModo = torneo.tipo === 'tactico' ? 'fechas_ganadas_tactico' : torneo.tipo === 'libre' ? 'fechas_ganadas_libre' : null;
            if (campoFechasModo) {
              const { data: perfilFechas } = await supabase.from('perfiles').select(campoFechasModo).eq('id', ganador.user_id).single();
              const fechasGanadasModo = (perfilFechas?.[campoFechasModo] || 0);
              const esTactico = torneo.tipo === 'tactico';
              const HITOS_FECHAS = [
                { n: 1,  subtipo: esTactico ? 'primera_fecha_tac' : 'primera_fecha_lib', emoji: '1rimerfecha.png', nombre: esTactico ? 'Primera fecha táctica' : 'Primera fecha libre', desc: `Ganaste tu primera fecha ${esTactico ? 'táctica' : 'libre'}` },
                { n: 5,  subtipo: esTactico ? '5fechas'           : '5fechas_lib',       emoji: '5fechas.png',     nombre: esTactico ? '5 fechas tácticas'     : '5 fechas libres',     desc: `Ganaste 5 fechas ${esTactico ? 'tácticas' : 'libres'}` },
                { n: 10, subtipo: esTactico ? '10fechas'          : '10fechas_lib',      emoji: '10fechas.png',    nombre: esTactico ? '10 fechas tácticas'    : '10 fechas libres',    desc: `Ganaste 10 fechas ${esTactico ? 'tácticas' : 'libres'}` },
              ];
              for (const hito of HITOS_FECHAS) {
                if (fechasGanadasModo + 1 === hito.n) { // +1 porque aún no se guardó
                  const { count: yaHito } = await supabase.from('medallas_usuario')
                    .select('id', { count: 'exact', head: true })
                    .eq('user_id', ganador.user_id).eq('subtipo', hito.subtipo);
                  if (!yaHito) {
                    await supabase.from('medallas_usuario').insert({
                      user_id: ganador.user_id, tipo: 'hito', subtipo: hito.subtipo,
                      emoji: hito.emoji, nombre: hito.nombre, descripcion: hito.desc, visible: true,
                    });
                    await supabase.from('notificaciones').insert({
                      user_id: ganador.user_id, tipo: 'medalla',
                      texto: `🏅 Nuevo hito: ${hito.nombre}`, emoji: hito.emoji, leida: false,
                    });
                  }
                }
              }
            }
          }
          console.log('Medallas de fecha distribuidas');
        } catch(e) { console.error('Error medallas fecha:', e); }

        // ⚠️ Jugadas Preparadas — detectar medallas ocultas
        try {
          await detectarJugadasPreparadas(jornadaTorneo);
        } catch(e) { console.error('Error jugadas preparadas:', e); }

        // ⚠️ Aportes de restricciones → hitos Mago/Adivino/Oráculo
        try {
          await procesarRestriccionesAportes(jornadaTorneo);
        } catch(e) { console.error('Error restricciones aportes:', e); }

        setDistribucionLog({ ok: true, msg: `✓ ${totalUpserts} equipos actualizados — Jornada ${jornadaTorneo} cerrada, jornada ${jornadaTorneo + 1} activa.` });
      }
    } catch (err) {
      setDistribucionLog({ ok: false, msg: `Error inesperado: ${err.message}` });
    }
    setDistribuyendo(false);
  };

  const [calculandoProde, setCalculandoProde] = useState(false);
  const [prodeLog, setProdeLog] = useState(null);

  const calcularPuntosProde = async () => {
    setCalculandoProde(true);
    setProdeLog(null);
    try {
      // 1. Calcular tipo_acierto y puntos_ganados para todos los pronósticos de partidos finalizados

      // Si no hay RPC, hacemos el cálculo manual con queries separadas
      // Traer todos los partidos finalizados con resultado
      const { data: finalizados } = await supabase
        .from('mundial_partidos')
        .select('id, goles_local, goles_visitante')
        .eq('estado', 'finalizado')
        .not('goles_local', 'is', null);

      if (!finalizados?.length) {
        setProdeLog({ ok: false, msg: 'No hay partidos finalizados con resultado cargado.' });
        setCalculandoProde(false);
        return;
      }

      let actualizados = 0;
      for (const partido of finalizados) {
        const gl = partido.goles_local, gv = partido.goles_visitante;
        const difReal = gl - gv;

        // Traer todos los pronósticos de este partido
        const { data: prons } = await supabase
          .from('prode_pronosticos')
          .select('id, goles_local, goles_visitante')
          .eq('mundial_partido_id', partido.id);

        for (const pron of (prons || [])) {
          const pl = pron.goles_local, pv = pron.goles_visitante;
          const difPron = pl - pv;

          let tipo, puntos;
          if (pl === gl && pv === gv) {
            tipo = 'exacto'; puntos = 5;
          } else if (difPron === difReal) {
            // Misma diferencia (incluye empates: 1-1 vs 0-0 → dif 0 = 0)
            tipo = 'diferencia'; puntos = 3;
          } else if ((pl > pv && gl > gv) || (pl < pv && gl < gv) || (pl === pv && gl === gv)) {
            // Solo acertó el ganador/empate
            tipo = 'parcial'; puntos = 2;
          } else {
            tipo = 'error'; puntos = 0;
          }

          await supabase.from('prode_pronosticos')
            .update({ tipo_acierto: tipo, puntos_ganados: puntos })
            .eq('id', pron.id);
          actualizados++;
        }
      }

      // 2. Recalcular puntos_totales de cada participante
      const { data: participantes } = await supabase
        .from('prode_participantes').select('id, torneo_id, user_id');

      for (const part of (participantes || [])) {
        const { data: suma } = await supabase
          .from('prode_pronosticos')
          .select('puntos_ganados')
          .eq('torneo_id', part.torneo_id)
          .eq('user_id', part.user_id);
        const total = (suma || []).reduce((acc, p) => acc + (p.puntos_ganados || 0), 0);
        await supabase.from('prode_participantes')
          .update({ puntos_totales: total })
          .eq('id', part.id);
      }

      // 3. Medallas por exactos acumulados (1/5/10/15/20)
      try {
        const HITOS_EXACTOS = [
          { n: 1,  subtipo: 'prode_ex1_v2',  emoji: 'prodebronce1.png',    nombre: 'Primer Exacto',    desc: 'Acertaste 1 resultado exacto' },
          { n: 5,  subtipo: 'prode_ex5_v2',  emoji: 'prodeplata5.png',     nombre: 'Cinco Exactos',    desc: 'Acertaste 5 resultados exactos' },
          { n: 10, subtipo: 'prode_ex10_v2', emoji: 'prodeoro10.png',      nombre: 'Diez Exactos',     desc: 'Acertaste 10 resultados exactos' },
          { n: 15, subtipo: 'prode_ex15_v2', emoji: 'prodediamante15p.png',nombre: 'Cirujano',         desc: 'Acertaste 15 resultados exactos' },
          { n: 20, subtipo: 'prode_ex20_v2', emoji: 'prodemaestro20.png',  nombre: 'Maestro del Prode',desc: 'Acertaste 20 resultados exactos' },
        ];

        // Por cada participante, contar sus exactos acumulados en TODOS los prodes
        const { data: todosParticipantes } = await supabase
          .from('prode_participantes').select('user_id').then(r => r);

        const uniqueUsers = [...new Set((todosParticipantes || []).map(p => p.user_id))];

        for (const userId of uniqueUsers) {
          const { count: totalExactos } = await supabase
            .from('prode_pronosticos')
            .select('id', { count: 'exact', head: true })
            .eq('user_id', userId)
            .eq('tipo_acierto', 'exacto');

          for (const hito of HITOS_EXACTOS) {
            if ((totalExactos || 0) >= hito.n) {
              const { count: yaExiste } = await supabase
                .from('medallas_usuario')
                .select('id', { count: 'exact', head: true })
                .eq('user_id', userId)
                .eq('subtipo', hito.subtipo);
              if (!yaExiste) {
                await supabase.from('medallas_usuario').insert({
                  user_id: userId, tipo: 'hito', subtipo: hito.subtipo,
                  emoji: hito.emoji, nombre: hito.nombre, descripcion: hito.desc, visible: true,
                });
                await supabase.from('notificaciones').insert({
                  user_id: userId, tipo: 'medalla',
                  texto: `🏅 Nuevo hito: ${hito.nombre}`, emoji: hito.emoji, leida: false,
                });
              }
            }
          }
        }
      } catch(e) { console.error('Error medallas exactos:', e); }

      // 4. Otorgar medalla al ganador de cada prode de clan (si cerró en esta jornada)
      try {
        const { data: prodesTorneo } = await supabase
          .from('prode_torneos').select('id, nombre, clan_id');

        for (const prode of (prodesTorneo || [])) {
          const { data: ranking } = await supabase
            .from('prode_participantes')
            .select('user_id, puntos_totales')
            .eq('torneo_id', prode.id)
            .order('puntos_totales', { ascending: false });

          if (!ranking?.length) continue;
          const n = ranking.length;
          if (n < 5) continue; // mínimo 5 para medalla

          const ganador = ranking[0];
          if (!ganador || ganador.puntos_totales <= 0) continue;

          const tier = n >= 50 ? { nivel: 'legendario', emoji: 'prodelegendario.png', nombre: 'Legendario Prode' }
                     : n >= 25 ? { nivel: 'diamante',   emoji: 'prodediamante.png',  nombre: 'Diamante Prode' }
                     : n >= 15 ? { nivel: 'oro',        emoji: 'prodeoro.png',       nombre: 'Oro Prode' }
                     : n >= 10 ? { nivel: 'plata',      emoji: 'prodeplata.png',     nombre: 'Plata Prode' }
                     :           { nivel: 'bronce',     emoji: 'prodebronce.png',    nombre: 'Bronce Prode' };

          const prode_subtipo = `prode_${tier.nivel}`;
          const { count: yaProde } = await supabase.from('medallas_usuario')
            .select('id', { count: 'exact', head: true })
            .eq('user_id', ganador.user_id).eq('subtipo', prode_subtipo).eq('torneo_nombre', prode.nombre);
          if (!yaProde) {
            await supabase.from('medallas_usuario').insert({
              user_id:      ganador.user_id,
              tipo:         'fecha_torneo',
              subtipo:      prode_subtipo,
              emoji:        tier.emoji,
              nombre:       tier.nombre,
              descripcion:  `Ganaste el prode con ${n} participantes`,
              torneo_nombre: prode.nombre,
              participantes: n,
            });
            await supabase.from('notificaciones').insert({
              user_id: ganador.user_id, tipo: 'medalla',
              texto: `🏅 ¡Ganaste el prode! ${tier.nombre}`, emoji: tier.emoji, leida: false,
            });
          }

          if (prode.clan_id) {
            await supabase.rpc('otorgar_medalla_fecha', {
              p_user_id: ganador.user_id,
              p_clan_id: prode.clan_id,
            });
          }
        }
      } catch(e) { console.error('Error medallas prode:', e); }

      setProdeLog({ ok: true, msg: `✓ ${actualizados} pronósticos actualizados. Ranking del prode recalculado.` });
    } catch (err) {
      setProdeLog({ ok: false, msg: `Error: ${err.message}` });
    }
    setCalculandoProde(false);
  };

  const JORNADA_NOMBRE = {
    1:'Jornada 1 — Grupos', 2:'Jornada 2 — Grupos',
    3:'Jornada 3 — Grupos', 4:'Dieciseisavos', 5:'Octavos',
    6:'Cuartos', 7:'Semifinales', 8:'Tercer Lugar', 9:'Final',
  };
  const JORNADA_LABEL = { 1:'Grupos J1', 2:'Grupos J2', 3:'Grupos J3', 4:'Dieciseisavos', 5:'Octavos', 6:'Cuartos', 7:'Semifinales', 8:'Tercer Lugar', 9:'Final' };

  // Hooks — siempre antes del return condicional
  useEffect(() => {
    const cargar = async () => {
      setLoadingPartidos(true);
      const { data } = await supabase.from('mundial_partidos')
        .select('*').eq('jornada_nombre', JORNADA_NOMBRE[jornada]).order('hora');
      setPartidos(data || []);
      setPartidoActivo(null);
      setJugadores([]);
      setLoadingPartidos(false);
    };
    cargar();
  }, [jornada]);

  useEffect(() => {
    if (!partidoActivo) { setJugadores([]); return; }
    const cargar = async () => {
      setLoadingJugadores(true);
      const local     = partidoActivo.equipo_local;
      const visitante = partidoActivo.equipo_visitante;
      const equipos = [...new Set([
        local, visitante,
        SELECCION_ES[local]||'', SELECCION_ES[visitante]||'',
      ])].filter(Boolean);
      const { data } = await supabase.from('jugadores')
        .select('id, nombre, apellido, seleccion, posicion:posiciones(sigla)')
        .eq('contexto', 'mundial')
        .in('seleccion', equipos)
        .order('seleccion').order('apellido');
      setJugadores(data || []);
      setLoadingJugadores(false);
    };
    cargar();
  }, [partidoActivo]);

  if (!esAdmin) return (
    <div style={{ padding:'60px', textAlign:'center', color:'#334155', background:'#020b18', minHeight:'calc(100vh - 46px)' }}>
      <p style={{ fontSize:'2.5rem', margin:'0 0 12px' }}></p>
      <p>No tenés acceso a esta sección.</p>
    </div>
  );

  const POS_ORDER = { ARQ:0, DEF:1, VOL:2, DEL:3 };

  // Agrupar por selección
  const porSeleccion = {};
  jugadores.forEach(j => {
    const k = j.seleccion;
    if (!porSeleccion[k]) porSeleccion[k] = [];
    porSeleccion[k].push(j);
  });
  Object.values(porSeleccion).forEach(arr =>
    arr.sort((a,b) => (POS_ORDER[a.posicion?.sigla]??9)-(POS_ORDER[b.posicion?.sigla]??9) || a.apellido.localeCompare(b.apellido))
  );

  const getJugadoresEquipo = equipo =>
    porSeleccion[equipo] || porSeleccion[SELECCION_ES[equipo]] || [];

  const porFecha = {};
  partidos.forEach(p => {
    const f = new Date(p.hora).toLocaleDateString('es-AR',{ day:'2-digit', month:'2-digit', timeZone:'America/Argentina/Buenos_Aires' });
    if (!porFecha[f]) porFecha[f] = [];
    porFecha[f].push(p);
  });

  const equipos = partidoActivo
    ? [partidoActivo.equipo_local, partidoActivo.equipo_visitante]
    : [];
  const equipoActivo = equipos[equipoIdx] || '';
  const jugadoresEquipo = getJugadoresEquipo(equipoActivo);

  return (
    <div style={{ padding:'18px 24px', color:'white', minHeight:'calc(100vh - 46px)', background:'#020b18' }}>

      {/* Header */}
      <div style={{ marginBottom:'16px', display:'flex', alignItems:'center', gap:'12px', flexWrap:'wrap' }}>
        <div>
          <h1 style={{ margin:0, fontSize:'1.3rem', letterSpacing:'1px' }}>
            ADMIN — <span style={{ color:'#00f2ff' }}>CARGA DE PUNTOS</span>
          </h1>
          <p style={{ margin:'2px 0 0', color:'#475569', fontSize:'0.78rem' }}>Los puntos aplican globalmente a todos los torneos</p>
        </div>
        {guardadosCount > 0 && (
          <div style={{ marginLeft:'auto', background:'#22c55e15', border:'1px solid #22c55e44', borderRadius:'8px', padding:'5px 12px', color:'#22c55e', fontSize:'0.78rem', fontWeight:'bold' }}>
            ✓ {guardadosCount} guardados esta sesión
          </div>
        )}
      </div>

      {/* Tabs */}
      <div style={{ display:'flex', gap:'6px', marginBottom:'18px' }}>
        {[['partidos',' Partidos & Calificaciones'],['distribucion',' Distribución'],['goleadores','⚽ Goleadores'],['status','Estado jugadores'],['cruces','Cargar cruces']].map(([t, label]) => (
          <button key={t} onClick={() => setAdminTab(t)} style={{
            padding:'9px 22px', borderRadius:'8px', cursor:'pointer',
            fontWeight:'bold', fontSize:'0.85rem', transition:'0.2s',
            background: adminTab === t ? '#00f2ff22' : '#080d14',
            border: `1px solid ${adminTab === t ? '#00f2ff' : '#1e293b'}`,
            color: adminTab === t ? '#00f2ff' : '#475569',
          }}>{label}</button>
        ))}
      </div>

      {adminTab === 'goleadores' && (() => {
        const norm = s => (s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
        const cargarTabla = async () => {
          const { data } = await supabase.from('mundial_goleadores').select('*').order('goles', { ascending: false });
          setGolTabla(data || []);
        };
        if (golTabla.length === 0) cargarTabla();
        const buscar = async (q) => {
          if (q.length < 2) { setGolDropdown([]); return; }
          const { data } = await supabase.from('jugadores')
            .select('id, nombre, apellido, seleccion, posicion:posiciones(sigla)')
            .eq('contexto','mundial')
            .or(`apellido.ilike.%${q}%,nombre.ilike.%${q}%`)
            .order('apellido').limit(20);
          const qn = norm(q);
          setGolDropdown((data||[]).filter(j => norm(j.apellido).includes(qn) || norm(j.nombre).includes(qn)));
        };
        const seleccionar = (j) => {
          setGolJugador(j); setGolBusqueda(`${j.nombre} ${j.apellido}`); setGolDropdown([]);
          const exist = golTabla.find(g => g.jugador_id === j.id);
          setGolGoles(exist?.goles || 0); setGolAsist(exist?.asistencias || 0);
        };
        const guardar = async () => {
          if (!golJugador) return;
          setGolGuardando(true); setGolMensaje('');
          const { error } = await supabase.from('mundial_goleadores').upsert({
            jugador_id: golJugador.id, nombre: `${golJugador.nombre} ${golJugador.apellido}`,
            seleccion: golJugador.seleccion, goles: parseInt(golGoles)||0,
            asistencias: parseInt(golAsist)||0, updated_at: new Date().toISOString(),
          }, { onConflict: 'jugador_id' });
          setGolGuardando(false);
          if (error) setGolMensaje('❌ ' + error.message);
          else { setGolMensaje('✅ Guardado'); setGolJugador(null); setGolBusqueda(''); setGolGoles(0); setGolAsist(0); cargarTabla(); }
        };
        return (
          <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
            <div style={{ background:'#080d14', border:'1px solid #1e293b', borderRadius:'12px', padding:'20px', display:'flex', flexDirection:'column', gap:'12px' }}>
              <h3 style={{ color:'#00f2ff', fontSize:'0.85rem', textTransform:'uppercase', letterSpacing:'1px', margin:0 }}>Cargar Gol / Asistencia</h3>
              <div style={{ position:'relative' }}>
                <input value={golBusqueda} onChange={e => { setGolBusqueda(e.target.value); setGolJugador(null); buscar(e.target.value); }}
                  placeholder="Buscar jugador mundial..." style={{ width:'100%', padding:'10px 14px', background:'#0a0f19', border:'1px solid #1e293b', borderRadius:'8px', color:'#fff', fontSize:'0.9rem', boxSizing:'border-box', outline:'none' }} />
                {golDropdown.length > 0 && (
                  <div style={{ position:'absolute', top:'100%', left:0, right:0, zIndex:100, background:'#0f172a', border:'1px solid #1e293b', borderRadius:'8px', marginTop:'4px', overflow:'hidden', maxHeight:'220px', overflowY:'auto' }}>
                    {golDropdown.map(j => (
                      <div key={j.id} onClick={() => seleccionar(j)} style={{ padding:'9px 14px', cursor:'pointer', fontSize:'0.88rem', color:'#e2e8f0', borderBottom:'1px solid #1e293b', display:'flex', justifyContent:'space-between' }}>
                        <span>{j.nombre} {j.apellido}</span>
                        <span style={{ color:'#475569', fontSize:'0.75rem' }}>{j.seleccion} · {j.posicion?.sigla}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {golJugador && (<>
                <div style={{ background:'#0a0f19', border:'1px solid #22c55e33', borderRadius:'8px', padding:'8px 14px' }}>
                  <span style={{ color:'#22c55e', fontSize:'0.82rem' }}>✓ {golJugador.nombre} {golJugador.apellido} — {golJugador.seleccion}</span>
                </div>
                <div style={{ display:'flex', gap:'10px' }}>
                  {[['⚽ Goles', golGoles, setGolGoles], ['🎯 Asistencias', golAsist, setGolAsist]].map(([label, val, setter]) => (
                    <div key={label} style={{ flex:1 }}>
                      <p style={{ color:'#475569', fontSize:'0.72rem', margin:'0 0 4px', textTransform:'uppercase' }}>{label}</p>
                      <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                        <button onClick={() => setter(Math.max(0,parseInt(val)-1))} style={{ width:'30px', height:'30px', background:'#1e293b', border:'none', borderRadius:'6px', color:'#fff', cursor:'pointer', fontSize:'1rem' }}>−</button>
                        <input type="number" min="0" value={val} onChange={e => setter(parseInt(e.target.value)||0)} style={{ width:'50px', textAlign:'center', padding:'6px', background:'#0a0f19', border:'1px solid #1e293b', borderRadius:'6px', color:'#fff', fontSize:'0.9rem' }} />
                        <button onClick={() => setter(parseInt(val)+1)} style={{ width:'30px', height:'30px', background:'#1e293b', border:'none', borderRadius:'6px', color:'#fff', cursor:'pointer', fontSize:'1rem' }}>+</button>
                      </div>
                    </div>
                  ))}
                </div>
                <button onClick={guardar} disabled={golGuardando} style={{ padding:'11px', background: golGuardando?'#1e293b':'#00f2ff', color: golGuardando?'#475569':'#000', border:'none', borderRadius:'8px', fontWeight:'bold', fontSize:'0.9rem', cursor: golGuardando?'default':'pointer' }}>
                  {golGuardando ? 'Guardando...' : '💾 Guardar'}
                </button>
                {golMensaje && <p style={{ color: golMensaje.startsWith('✅')?'#22c55e':'#ef4444', fontSize:'0.82rem', margin:0 }}>{golMensaje}</p>}
              </>)}
            </div>
            {golTabla.length > 0 && (
              <div style={{ background:'#080d14', border:'1px solid #1e293b', borderRadius:'12px', padding:'20px' }}>
                <h3 style={{ color:'#00f2ff', fontSize:'0.85rem', textTransform:'uppercase', letterSpacing:'1px', margin:'0 0 14px' }}>Tabla actual</h3>
                <div style={{ display:'flex', flexDirection:'column', gap:'4px' }}>
                  {golTabla.map((g,i) => (
                    <div key={g.jugador_id} onClick={() => { const p=(g.nombre||'').split(' '); setGolJugador({id:g.jugador_id,nombre:p[0]||g.nombre,apellido:p.slice(1).join(' ')||'',seleccion:g.seleccion}); setGolBusqueda(g.nombre); setGolGoles(g.goles); setGolAsist(g.asistencias||0); }}
                      style={{ display:'flex', alignItems:'center', gap:'10px', padding:'8px 12px', background:'#0a0f19', borderRadius:'8px', border:'1px solid #1e293b', cursor:'pointer' }}>
                      <span style={{ color:'#475569', fontSize:'0.72rem', minWidth:'18px' }}>#{i+1}</span>
                      <span style={{ flex:1, color:'#e2e8f0', fontSize:'0.85rem' }}>{g.nombre}</span>
                      <span style={{ color:'#64748b', fontSize:'0.72rem' }}>{g.seleccion}</span>
                      <span style={{ color:'#f59e0b', fontWeight:'bold', fontSize:'0.85rem', minWidth:'40px', textAlign:'right' }}>⚽ {g.goles}</span>
                      <span style={{ color:'#22c55e', fontSize:'0.82rem', minWidth:'40px', textAlign:'right' }}>🎯 {g.asistencias||0}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      })()}

      {adminTab === 'status' && (() => {
        const norm = s => (s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'');

        const buscarSeleccion = async (q) => {
          if (q.length < 2) { setStDropdown([]); return; }
          const qn = norm(q);
          // Buscar selecciones distintas de jugadores mundiales
          const { data } = await supabase.from('jugadores')
            .select('seleccion').eq('contexto','mundial').neq('seleccion', null);
          const sels = [...new Set((data||[]).map(j => j.seleccion))].filter(s => norm(s).includes(qn)).sort();
          setStDropdown(sels.slice(0, 12));
        };

        const cargarJugadores = async (seleccion) => {
          setStSeleccion(seleccion);
          setStDropdown([]);
          setStBusqueda(seleccion);
          setStCambios({});
          setStMensaje('');
          const { data } = await supabase.from('jugadores')
            .select('id, nombre, apellido, status, posicion:posiciones(sigla), dorsal')
            .eq('contexto','mundial').eq('seleccion', seleccion)
            .order('dorsal', { ascending: true });
          setStJugadores(data || []);
        };

        const setStatus = (id, val) => {
          setStCambios(prev => ({ ...prev, [id]: val }));
        };

        const guardar = async () => {
          setStGuardando(true); setStMensaje('');
          const updates = stJugadores.map(j => ({
            id: j.id,
            status: stCambios[j.id] ?? j.status,
          }));
          let err = null;
          for (const u of updates) {
            const { error } = await supabase.from('jugadores').update({ status: u.status }).eq('id', u.id);
            if (error) { err = error; break; }
          }
          setStGuardando(false);
          if (err) setStMensaje('Error: ' + err.message);
          else {
            setStMensaje('Guardado');
            // Actualizar estado local
            setStJugadores(prev => prev.map(j => ({ ...j, status: stCambios[j.id] ?? j.status })));
            setStCambios({});
            setTimeout(() => setStMensaje(''), 2500);
          }
        };

        const STATUS_OPS = [
          { val: 'titular',  label: 'Titular',  color: '#22c55e' },
          { val: 'duda',     label: 'Duda',     color: '#f59e0b' },
          { val: 'no_juega', label: 'No juega', color: '#ef4444' },
        ];

        return (
          <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
            <div style={{ background:'#080d14', border:'1px solid #1e293b', borderRadius:'12px', padding:'20px', display:'flex', flexDirection:'column', gap:'12px' }}>
              <h3 style={{ color:'#00f2ff', fontSize:'0.85rem', textTransform:'uppercase', letterSpacing:'1px', margin:0 }}>Estado de jugadores por selección</h3>
              <div style={{ position:'relative' }}>
                <input
                  value={stBusqueda}
                  onChange={e => { setStBusqueda(e.target.value); setStSeleccion(null); setStJugadores([]); buscarSeleccion(e.target.value); }}
                  placeholder="Buscar selección (ej: Argentina)..."
                  style={{ width:'100%', padding:'10px 14px', background:'#0a0f19', border:'1px solid #1e293b', borderRadius:'8px', color:'#fff', fontSize:'0.9rem', boxSizing:'border-box', outline:'none' }}
                />
                {stDropdown.length > 0 && (
                  <div style={{ position:'absolute', top:'100%', left:0, right:0, zIndex:100, background:'#0f172a', border:'1px solid #1e293b', borderRadius:'8px', marginTop:'4px', overflow:'hidden', maxHeight:'220px', overflowY:'auto' }}>
                    {stDropdown.map(s => (
                      <div key={s} onClick={() => cargarJugadores(s)}
                        style={{ padding:'9px 14px', cursor:'pointer', fontSize:'0.88rem', color:'#e2e8f0', borderBottom:'1px solid #1e293b', display:'flex', alignItems:'center', gap:'8px' }}>
                        <span>{EMOJIS[s]||''}</span><span>{s}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {stJugadores.length > 0 && (
                <>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <p style={{ color:'#22c55e', fontSize:'0.82rem', margin:0 }}>{stSeleccion} — {stJugadores.length} jugadores</p>
                    <div style={{ display:'flex', gap:'8px', flexWrap:'wrap' }}>
                      {STATUS_OPS.map(op => (
                        <span key={op.val} style={{ fontSize:'0.7rem', color:op.color, background:op.color+'22', border:`1px solid ${op.color}44`, borderRadius:'4px', padding:'2px 8px' }}>{op.label}</span>
                      ))}
                    </div>
                  </div>
                  <div style={{ display:'flex', flexDirection:'column', gap:'4px' }}>
                    {(() => {
                      const POS_ORD = ['ARQ','DEF','VOL','DEL'];
                      const grupos = POS_ORD.map(sig => ({
                        sig,
                        jugadores: stJugadores.filter(j => j.posicion?.sigla === sig),
                      })).filter(g => g.jugadores.length > 0);
                      return grupos.map((g, gi) => (
                        <React.Fragment key={g.sig}>
                          {gi > 0 && <div style={{ borderTop:'1px solid #1e293b', margin:'6px 0 2px' }} />}
                          <p style={{ color:'#475569', fontSize:'0.62rem', textTransform:'uppercase', letterSpacing:'1px', margin:'0 0 4px', paddingLeft:'4px' }}>{g.sig}</p>
                          {g.jugadores.map(j => {
                            const statusActual = stCambios[j.id] ?? j.status;
                            const cambiado = stCambios[j.id] && stCambios[j.id] !== j.status;
                            return (
                              <div key={j.id} style={{ display:'flex', alignItems:'center', gap:'8px', padding:'8px 12px', background: cambiado ? '#0a1628' : '#0a0f19', border:`1px solid ${cambiado ? '#00f2ff44' : '#1e293b'}`, borderRadius:'8px' }}>
                                <span style={{ color:'#475569', fontSize:'0.72rem', minWidth:'22px' }}>{j.dorsal}</span>
                                <span style={{ flex:1, color:'#e2e8f0', fontSize:'0.85rem' }}>{j.nombre} {j.apellido}</span>
                                <div style={{ display:'flex', gap:'4px' }}>
                                  {STATUS_OPS.map(op => (
                                    <button key={op.val} onClick={() => setStatus(j.id, op.val)}
                                      style={{ padding:'3px 8px', borderRadius:'5px', cursor:'pointer', fontSize:'0.68rem', fontWeight:'bold', transition:'0.15s',
                                        background: statusActual === op.val ? op.color+'33' : 'transparent',
                                        border: `1px solid ${statusActual === op.val ? op.color : '#1e293b'}`,
                                        color: statusActual === op.val ? op.color : '#334155',
                                      }}>
                                      {op.label}
                                    </button>
                                  ))}
                                </div>
                              </div>
                            );
                          })}
                        </React.Fragment>
                      ));
                    })()}
                  </div>
                  <button onClick={guardar} disabled={stGuardando}
                    style={{ padding:'11px', background: stGuardando?'#1e293b':'#00f2ff', color: stGuardando?'#475569':'#000', border:'none', borderRadius:'8px', fontWeight:'bold', fontSize:'0.9rem', cursor: stGuardando?'default':'pointer' }}>
                    {stGuardando ? 'Guardando...' : `Guardar ${stSeleccion}`}
                  </button>
                  {stMensaje && <p style={{ color: stMensaje.startsWith('Error') ? '#ef4444' : '#22c55e', fontSize:'0.82rem', margin:0 }}>{stMensaje}</p>}
                </>
              )}
            </div>
          </div>
        );
      })()}

      {/* ── TAB CRUCES ── */}
      {adminTab === 'cruces' && (() => {
        const FASES = [
          { num: 4, label: 'Dieciseisavos', nombre: 'Dieciseisavos' },
          { num: 5, label: 'Octavos',       nombre: 'Octavos' },
          { num: 6, label: 'Cuartos',       nombre: 'Cuartos' },
          { num: 7, label: 'Semifinales',   nombre: 'Semifinales' },
          { num: 8, label: 'Tercer Lugar',  nombre: 'Tercer Lugar' },
          { num: 9, label: 'Final',         nombre: 'Final' },
        ];

        const norm = s => (s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
        const selLista = cruceSelLista;
        const dropActivo = cruceDropActivo;
        const setDropActivo = setCruceDropActivo;

        const sugerencias = (query) => {
          if (!query || query.length < 1) return [];
          const q = norm(query);
          return selLista.filter(s => norm(s).includes(q)).slice(0, 8);
        };

        const cargarCruces = async (fase) => {
          setCruceFase(fase);
          setCruceCargando(true);
          setCruceEdits({});
          setCruceMensaje('');
          const { data } = await supabase.from('mundial_partidos')
            .select('id, equipo_local, equipo_visitante, hora, cierre_pronosticos, jornada_nombre')
            .eq('jornada', fase).order('hora');
          setCrucePartidos(data || []);
          // Init edits con valores actuales
          const edits = {};
          for (const p of (data || [])) {
            edits[p.id] = {
              local: p.equipo_local || '',
              visitante: p.equipo_visitante || '',
              hora: p.hora ? new Date(p.hora).toISOString().slice(0,16) : '',
            };
          }
          setCruceEdits(edits);
          setCruceCargando(false);
        };

        const setEdit = (id, field, val) => {
          setCruceEdits(prev => ({ ...prev, [id]: { ...prev[id], [field]: val } }));
        };

        const guardarPartido = async (p) => {
          const edit = cruceEdits[p.id];
          if (!edit) return;
          const horaUTC = edit.hora ? new Date(edit.hora).toISOString() : p.hora;
          const cierre = edit.hora ? new Date(new Date(edit.hora).getTime() - 30*60*1000).toISOString() : p.cierre_pronosticos;
          const { error } = await supabase.from('mundial_partidos').update({
            equipo_local: edit.local,
            equipo_visitante: edit.visitante,
            hora: horaUTC,
            cierre_pronosticos: cierre,
          }).eq('id', p.id);
          if (error) setCruceMensaje('Error: ' + error.message);
          else {
            setCruceMensaje('Guardado: ' + edit.local + ' vs ' + edit.visitante);
            setTimeout(() => setCruceMensaje(''), 3000);
            // Update local state
            setCrucePartidos(prev => prev.map(pp => pp.id === p.id
              ? { ...pp, equipo_local: edit.local, equipo_visitante: edit.visitante, hora: horaUTC, cierre_pronosticos: cierre }
              : pp
            ));
          }
        };

        const formatHoraLocal = (iso) => {
          if (!iso) return '';
          return new Date(iso).toLocaleString('es-AR', { weekday:'short', day:'2-digit', month:'2-digit', hour:'2-digit', minute:'2-digit', timeZone:'America/Argentina/Buenos_Aires' });
        };

        return (
          <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
            {/* Selector de fase */}
            <div style={{ display:'flex', gap:'8px', flexWrap:'wrap' }}>
              {FASES.map(f => (
                <button key={f.num} onClick={() => cargarCruces(f.num)}
                  style={{ padding:'7px 14px', borderRadius:'8px', cursor:'pointer', fontSize:'0.78rem', fontWeight:'bold', transition:'0.15s',
                    background: cruceFase === f.num ? '#00f2ff22' : 'transparent',
                    border: `1px solid ${cruceFase === f.num ? '#00f2ff' : '#1e293b'}`,
                    color: cruceFase === f.num ? '#00f2ff' : '#475569',
                  }}>
                  {f.label}
                </button>
              ))}
            </div>

            {cruceMensaje && <p style={{ color: cruceMensaje.startsWith('Error') ? '#ef4444' : '#22c55e', fontSize:'0.82rem', margin:0 }}>{cruceMensaje}</p>}

            {cruceCargando && <p style={{ color:'#475569', fontSize:'0.82rem' }}>Cargando...</p>}

            {!cruceCargando && crucePartidos.length === 0 && cruceFase && (
              <p style={{ color:'#475569', fontSize:'0.82rem' }}>No hay partidos en esta fase.</p>
            )}

            {!cruceCargando && crucePartidos.map(p => {
              const edit = cruceEdits[p.id] || {};
              const modificado = edit.local !== p.equipo_local || edit.visitante !== p.equipo_visitante ||
                (edit.hora && new Date(edit.hora).toISOString() !== p.hora);
              return (
                <div key={p.id} style={{ background:'#080d14', border:`1px solid ${modificado ? '#00f2ff44' : '#1e293b'}`, borderRadius:'12px', padding:'16px 18px', display:'flex', flexDirection:'column', gap:'10px' }}>
                  <p style={{ color:'#475569', fontSize:'0.65rem', textTransform:'uppercase', letterSpacing:'1px', margin:0 }}>
                    {formatHoraLocal(p.hora)}
                  </p>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr auto 1fr', alignItems:'center', gap:'10px' }}>
                    {['local','visitante'].reduce((acc, field, fi) => {
                      const isActive = dropActivo?.id === p.id && dropActivo?.field === field;
                      const sugs = isActive ? sugerencias(edit[field] || '') : [];
                      acc.push(
                        <div key={field} style={{ position:'relative' }}>
                          <input value={edit[field] || ''}
                            onChange={e => { setEdit(p.id, field, e.target.value); setDropActivo({ id: p.id, field }); }}
                            onFocus={() => setDropActivo({ id: p.id, field })}
                            onBlur={() => setTimeout(() => setDropActivo(null), 150)}
                            placeholder={field === 'local' ? 'Equipo local' : 'Equipo visitante'}
                            style={{ width:'100%', padding:'8px 12px', background:'#0a0f19', border:'1px solid #1e293b', borderRadius:'8px', color:'#fff', fontSize:'0.88rem', outline:'none', boxSizing:'border-box' }} />
                          {sugs.length > 0 && (
                            <div style={{ position:'absolute', top:'100%', left:0, right:0, zIndex:200, background:'#0f172a', border:'1px solid #1e293b', borderRadius:'8px', marginTop:'4px', overflow:'hidden' }}>
                              {sugs.map(s => (
                                <div key={s} onMouseDown={() => { setEdit(p.id, field, s); setDropActivo(null); }}
                                  style={{ padding:'8px 12px', cursor:'pointer', fontSize:'0.85rem', color:'#e2e8f0', borderBottom:'1px solid #0f172a' }}
                                  onMouseEnter={e => e.currentTarget.style.background='#1e293b'}
                                  onMouseLeave={e => e.currentTarget.style.background='transparent'}>
                                  {s}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                      if (fi === 0) acc.push(<span key="vs" style={{ color:'#334155', fontWeight:'bold' }}>vs</span>);
                      return acc;
                    }, [])}
                  </div>
                  <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
                    <span style={{ color:'#475569', fontSize:'0.72rem', whiteSpace:'nowrap' }}>Horario:</span>
                    <input type="datetime-local" value={edit.hora || ''} onChange={e => setEdit(p.id, 'hora', e.target.value)}
                      style={{ flex:1, padding:'6px 10px', background:'#0a0f19', border:'1px solid #1e293b', borderRadius:'8px', color:'#fff', fontSize:'0.82rem', outline:'none', colorScheme:'dark' }} />
                    <span style={{ color:'#334155', fontSize:'0.68rem', whiteSpace:'nowrap' }}>
                      Cierre: −30min auto
                    </span>
                  </div>
                  <button onClick={() => guardarPartido(p)} disabled={!modificado}
                    style={{ padding:'8px', borderRadius:'8px', border:'none', cursor: modificado ? 'pointer' : 'default', fontWeight:'bold', fontSize:'0.82rem', transition:'0.15s',
                      background: modificado ? '#00f2ff' : '#1e293b',
                      color: modificado ? '#000' : '#334155',
                    }}>
                    {modificado ? 'Guardar' : 'Sin cambios'}
                  </button>
                </div>
              );
            })}
          </div>
        );
      })()}

      {/* ── TAB PARTIDOS ── */}
      {adminTab === 'partidos' && (
        <div>
          {/* Selector jornada */}
          <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'14px', flexWrap:'wrap' }}>
            <span style={{ color:'#475569', fontSize:'0.78rem', fontWeight:'bold' }}>JORNADA</span>
            {[1,2,3,4,5,6,7,8,9].map(j => (
              <button key={j} onClick={() => { setJornada(j); setPartidoActivo(null); setJugadores([]); }}
                style={{ width:'32px', height:'32px', borderRadius:'6px', border:`1px solid ${jornada===j?'#00f2ff':'#1e293b'}`, background:jornada===j?'#00f2ff22':'#080d14', color:jornada===j?'#00f2ff':'#475569', cursor:'pointer', fontWeight:'bold', fontSize:'0.82rem' }}>
                {j}
              </button>
            ))}
            <span style={{ color:'#334155', fontSize:'0.72rem' }}>{JORNADA_LABEL[jornada]}</span>
            {partidoActivo && (
              <button onClick={() => { setPartidoActivo(null); setJugadores([]); setEquipoIdx(0); }}
                style={{ marginLeft:'auto', background:'none', border:'1px solid #334155', borderRadius:'6px', color:'#64748b', padding:'4px 12px', cursor:'pointer', fontSize:'0.75rem' }}>
                ← Volver al fixture
              </button>
            )}
          </div>

          {!partidoActivo ? (
            // ── FIXTURE ────────────────────────────────────────────────────
            loadingPartidos ? <p style={{ color:'#475569' }}>Cargando partidos...</p>
            : partidos.length === 0 ? <p style={{ color:'#334155' }}>No hay partidos para esta jornada</p>
            : (
              <div style={{ maxWidth:'700px' }}>
                {Object.entries(porFecha).map(([fecha, ps]) => (
                  <div key={fecha} style={{ marginBottom:'12px' }}>
                    <div style={{ color:'#334155', fontSize:'0.68rem', fontWeight:'bold', textTransform:'uppercase', letterSpacing:'1px', marginBottom:'5px', paddingLeft:'2px' }}>{fecha}</div>
                    {ps.map(p => (
                      <div key={p.id} onClick={() => { setPartidoActivo(p); setEquipoIdx(0); }}
                        style={{ display:'grid', gridTemplateColumns:'1fr auto 1fr auto', alignItems:'center', gap:'10px', padding:'10px 16px', background:'#080d14', border:'1px solid #1e293b', borderRadius:'10px', cursor:'pointer', marginBottom:'5px', transition:'0.15s' }}
                        onMouseEnter={e => e.currentTarget.style.borderColor='#00f2ff44'}
                        onMouseLeave={e => e.currentTarget.style.borderColor='#1e293b'}>
                        <div style={{ display:'flex', alignItems:'center', gap:'8px', justifyContent:'flex-end' }}>
                          <span style={{ color:'#e2e8f0', fontSize:'0.9rem' }}>{nombreEs(p.equipo_local)}</span>
                          <Bandera equipo={p.equipo_local} size={32} />
                        </div>
                        <div style={{ textAlign:'center', minWidth:'76px' }}>
                          {p.estado==='finalizado'||p.estado==='en curso'
                            ? <span style={{ color:'#fff', fontWeight:'bold', fontSize:'1rem', letterSpacing:'2px' }}>{p.goles_local??0}—{p.goles_visitante??0}</span>
                            : <span style={{ color:'#64748b', fontSize:'0.8rem' }}>{horaAR(p.hora)}</span>
                          }
                          {p.grupo && <div style={{ color:'#334155', fontSize:'0.58rem', marginTop:'1px' }}>Gr. {p.grupo}</div>}
                        </div>
                        <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
                          <Bandera equipo={p.equipo_visitante} size={32} />
                          <span style={{ color:'#e2e8f0', fontSize:'0.9rem' }}>{nombreEs(p.equipo_visitante)}</span>
                        </div>
                        <span style={{ color:'#334155' }}>›</span>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )
          ) : (
            // ── PARTIDO ACTIVO ──────────────────────────────────────────────
            <div>
              <div style={{ display:'flex', flexDirection:'column', gap:'10px', marginBottom:'14px', padding:'12px 20px', background:'#080d14', border:'1px solid #1e293b', borderRadius:'10px' }}>
                {/* Equipos y resultado */}
                <div style={{ display:'flex', alignItems:'center', gap:'16px' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:'10px', flex:1, justifyContent:'flex-end' }}>
                    <span style={{ color:'#e2e8f0', fontWeight:'bold', fontSize:'1rem' }}>{nombreEs(partidoActivo.equipo_local)}</span>
                    <Bandera equipo={partidoActivo.equipo_local} size={36} />
                  </div>
                  {/* Inputs de resultado */}
                  <div style={{ display:'flex', alignItems:'center', gap:'6px', flexShrink:0 }}>
                    <input type="number" min="0" max="20" value={resultadoLocal}
                      onChange={e => setResultadoLocal(e.target.value)}
                      style={{ width:'44px', height:'38px', textAlign:'center', background:'#0a0f19', border:'1px solid #1e293b', borderRadius:'6px', color:'#fff', fontSize:'1.2rem', fontWeight:'bold' }} />
                    <span style={{ color:'#334155', fontWeight:'bold' }}>—</span>
                    <input type="number" min="0" max="20" value={resultadoVisit}
                      onChange={e => setResultadoVisit(e.target.value)}
                      style={{ width:'44px', height:'38px', textAlign:'center', background:'#0a0f19', border:'1px solid #1e293b', borderRadius:'6px', color:'#fff', fontSize:'1.2rem', fontWeight:'bold' }} />
                  </div>
                  <div style={{ display:'flex', alignItems:'center', gap:'10px', flex:1 }}>
                    <Bandera equipo={partidoActivo.equipo_visitante} size={36} />
                    <span style={{ color:'#e2e8f0', fontWeight:'bold', fontSize:'1rem' }}>{nombreEs(partidoActivo.equipo_visitante)}</span>
                  </div>
                </div>
                {/* Botón guardar resultado */}
                <button onClick={guardarResultadoPartido}
                  disabled={guardandoResult || resultadoLocal === '' || resultadoVisit === ''}
                  style={{
                    padding:'7px 16px', borderRadius:'7px', fontWeight:'bold', fontSize:'0.8rem', cursor:'pointer', transition:'0.2s', border:'none',
                    background: resultadoOk ? '#22c55e' : (resultadoLocal !== '' && resultadoVisit !== '') ? '#00f2ff22' : '#080d14',
                    color: resultadoOk ? '#000' : (resultadoLocal !== '' && resultadoVisit !== '') ? '#00f2ff' : '#334155',
                    borderColor: resultadoOk ? '#22c55e' : '#00f2ff44',
                    border: `1px solid ${resultadoOk ? '#22c55e' : (resultadoLocal !== '' && resultadoVisit !== '') ? '#00f2ff44' : '#1e293b'}`,
                  }}>
                  {resultadoOk ? '✓ Resultado guardado → Prode actualizado' : guardandoResult ? 'Guardando...' : 'Guardar resultado (actualiza Prode)'}
                </button>
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'14px' }}>
                <button onClick={() => cambiarEquipo(0)}
                  style={{ display:'flex', alignItems:'center', gap:'8px', padding:'8px 16px', background:equipoIdx===0?'#00f2ff22':'#080d14', border:`1px solid ${equipoIdx===0?'#00f2ff':'#1e293b'}`, borderRadius:'8px', cursor:'pointer', color:equipoIdx===0?'#00f2ff':'#475569', fontWeight:'bold', fontSize:'0.88rem', transition:'0.15s' }}>
                  <Bandera equipo={partidoActivo.equipo_local} size={22} />
                  {nombreEs(partidoActivo.equipo_local)}
                  <span style={{ color:'#334155', fontSize:'0.7rem', fontWeight:'normal' }}>({getJugadoresEquipo(partidoActivo.equipo_local).length})</span>
                </button>
                <span style={{ color:'#1e293b', fontSize:'1.2rem' }}>⇄</span>
                <button onClick={() => cambiarEquipo(1)}
                  style={{ display:'flex', alignItems:'center', gap:'8px', padding:'8px 16px', background:equipoIdx===1?'#00f2ff22':'#080d14', border:`1px solid ${equipoIdx===1?'#00f2ff':'#1e293b'}`, borderRadius:'8px', cursor:'pointer', color:equipoIdx===1?'#00f2ff':'#475569', fontWeight:'bold', fontSize:'0.88rem', transition:'0.15s' }}>
                  <Bandera equipo={partidoActivo.equipo_visitante} size={22} />
                  {nombreEs(partidoActivo.equipo_visitante)}
                  <span style={{ color:'#334155', fontSize:'0.7rem', fontWeight:'normal' }}>({getJugadoresEquipo(partidoActivo.equipo_visitante).length})</span>
                </button>
              </div>
              {loadingJugadores ? <p style={{ color:'#475569' }}>Cargando...</p>
              : jugadoresEquipo.length === 0 ? (
                <div style={{ padding:'30px', textAlign:'center', color:'#334155' }}>
                  <p style={{ fontSize:'1.5rem' }}>😅</p>
                  <p>Sin jugadores cargados para {nombreEs(equipoActivo)}</p>
                </div>
              ) : (
                <>
                  {jugadoresEquipo.map(j => (
                    <FilaJugador key={`${j.id}-${equipoActivo}`} jugador={j} jornada={jornada}
                      onGuardado={() => setGuardadosCount(v=>v+1)}
                      onCambio={(id, formData) => setPendientesEquipo(prev => ({ ...prev, [id]: formData }))} />
                  ))}
                  <button onClick={guardarTodosEquipo} disabled={guardandoTodos || Object.values(pendientesEquipo).filter(f=>f.sofascore!=='').length === 0}
                    style={{
                      marginTop: '10px', width: '100%', padding: '12px',
                      background: guardadosTodosOk ? '#22c55e22' : Object.values(pendientesEquipo).filter(f=>f.sofascore!=='').length > 0 ? '#00f2ff22' : '#080d14',
                      border: `1px solid ${guardadosTodosOk ? '#22c55e' : Object.values(pendientesEquipo).filter(f=>f.sofascore!=='').length > 0 ? '#00f2ff' : '#1e293b'}`,
                      borderRadius: '8px', color: guardadosTodosOk ? '#22c55e' : Object.values(pendientesEquipo).filter(f=>f.sofascore!=='').length > 0 ? '#00f2ff' : '#334155',
                      fontWeight: 'bold', fontSize: '0.9rem', cursor: Object.values(pendientesEquipo).filter(f=>f.sofascore!=='').length > 0 ? 'pointer' : 'default', transition: '0.3s',
                    }}>
                    {guardadosTodosOk ? `✓ Guardados ${guardadosCount} jugadores` : guardandoTodos ? 'Guardando...' : `Guardar todos (${Object.values(pendientesEquipo).filter(f=>f.sofascore!=='').length} con datos)`}
                  </button>
                </>
              )}
            </div>
          )}
        </div>
      )}

      {/* ── TAB DISTRIBUCIÓN ── */}
      {adminTab === 'distribucion' && (
        <div style={{ display:'flex', flexDirection:'column', gap:'16px', maxWidth:'800px' }}>

          {/* Selector de jornada */}
          <div style={{ background:'#080d14', border:'1px solid #1e293b', borderRadius:'10px', padding:'12px 16px', display:'flex', alignItems:'center', gap:'10px', flexWrap:'wrap' }}>
            <span style={{ color:'#475569', fontSize:'0.75rem', fontWeight:'bold', textTransform:'uppercase', letterSpacing:'1px' }}>Jornada torneo</span>
            {[1,2,3,4,5,6,7,8,9,10].map(j => (
              <button key={j} onClick={() => setJornadaTorneo(j)}
                style={{ width:'30px', height:'30px', borderRadius:'5px', border:`1px solid ${jornadaTorneo===j?'#00f2ff':'#1e293b'}`, background:jornadaTorneo===j?'#00f2ff22':'#0a0f19', color:jornadaTorneo===j?'#00f2ff':'#475569', cursor:'pointer', fontWeight:'bold', fontSize:'0.78rem' }}>
                {j}
              </button>
            ))}
            <span style={{ color:'#334155', fontSize:'0.72rem' }}>Fecha {jornadaTorneo}</span>
          </div>

          {/* PASO 0 */}
          <div>
            <p style={{ color:'#334155', fontSize:'0.68rem', fontWeight:'bold', textTransform:'uppercase', letterSpacing:'2px', margin:'0 0 6px 2px' }}>— PASO 0 · Solo primera vez por temporada</p>
            <div style={{ background:'#080d14', border:'1px solid #22c55e33', borderRadius:'10px', padding:'14px 18px' }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'8px' }}>
                <div>
                  <span style={{ color:'#22c55e', fontSize:'0.75rem', fontWeight:'bold', textTransform:'uppercase', letterSpacing:'1px' }}>🎲 Auto-asignar torneos tácticos</span>
                  <p style={{ color:'#475569', fontSize:'0.68rem', margin:'3px 0 0' }}>Agrupa usuarios con equipo táctico confirmado en torneos DTXI TÁCTICO (5-10 jugadores) e inscribe a todos en el DTXI LIBRE #1. Idempotente — ignora los que ya están inscriptos.</p>
                </div>
                <button onClick={autoAsignarTorneos} disabled={asignandoTorneos}
                  style={{ flexShrink:0, padding:'9px 20px', background: asignandoTorneos ? '#0a0f19' : '#22c55e22', border:`1px solid ${asignandoTorneos?'#1e293b':'#22c55e'}`, borderRadius:'7px', color: asignandoTorneos ? '#475569' : '#22c55e', fontWeight:'bold', fontSize:'0.85rem', cursor: asignandoTorneos ? 'default' : 'pointer', transition:'0.2s', whiteSpace:'nowrap' }}>
                  {asignandoTorneos ? 'Asignando...' : ' Ejecutar'}
                </button>
              </div>
              {asignacionLog && (
                <div style={{ padding:'6px 12px', background: asignacionLog.ok ? '#22c55e10' : '#ef444410', border:`1px solid ${asignacionLog.ok ? '#22c55e33' : '#ef444433'}`, borderRadius:'7px', color: asignacionLog.ok ? '#22c55e' : '#ef4444', fontSize:'0.78rem' }}>
                  {asignacionLog.msg}
                </div>
              )}
            </div>
          </div>

          {/* PASO 1 */}
          <div>
            <p style={{ color:'#334155', fontSize:'0.68rem', fontWeight:'bold', textTransform:'uppercase', letterSpacing:'2px', margin:'0 0 6px 2px' }}>— PASO 1 · Antes de cargar puntos</p>
            <div style={{ background:'#080d14', border:'1px solid #00f2ff33', borderRadius:'10px', padding:'14px 18px' }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <div>
                  <span style={{ color:'#00f2ff', fontSize:'0.75rem', fontWeight:'bold', textTransform:'uppercase', letterSpacing:'1px' }}> Matchmaking 1v1 automático</span>
                  <p style={{ color:'#475569', fontSize:'0.68rem', margin:'3px 0 0' }}>Jornada {jornadaTorneo} — asigna 3 desafíos automáticos por usuario según división</p>
                </div>
                <button onClick={async () => {
                  const { data, error } = await supabase.rpc('matchmaking_automatico', { p_jornada: jornadaTorneo });
                  alert(error ? 'Error: ' + error.message : '✓ ' + data);
                }}
                  style={{ flexShrink:0, padding:'9px 20px', background:'#00f2ff22', border:'1px solid #00f2ff', borderRadius:'7px', color:'#00f2ff', fontWeight:'bold', fontSize:'0.85rem', cursor:'pointer', whiteSpace:'nowrap' }}>
                   Ejecutar
                </button>
              </div>
            </div>
          </div>

          {/* PASO 1.5 */}
          <div>
            <p style={{ color:'#334155', fontSize:'0.68rem', fontWeight:'bold', textTransform:'uppercase', letterSpacing:'2px', margin:'0 0 6px 2px' }}>— PASO 1.5 · Emparejar guerras de clan</p>
            <div style={{ background:'#080d14', border:'1px solid #8b5cf633', borderRadius:'10px', padding:'14px 18px' }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <div>
                  <span style={{ color:'#8b5cf6', fontSize:'0.75rem', fontWeight:'bold', textTransform:'uppercase', letterSpacing:'1px' }}> Asignar guerras automáticas de club</span>
                  <p style={{ color:'#475569', fontSize:'0.68rem', margin:'3px 0 0' }}>Empareja clanes para las guerras de la jornada {jornadaTorneo}. Solo una vez por jornada.</p>
                </div>
                <div style={{ display:'flex', gap:'8px', flexShrink:0 }}>
                  <button onClick={async () => {
                    const { data, error } = await supabase.rpc('matchmaking_retos', { p_forzar: true });
                    alert(error ? 'Error: ' + error.message : '✓ ' + data);
                  }}
                    style={{ padding:'9px 14px', background:'#8b5cf622', border:'1px solid #8b5cf6', borderRadius:'7px', color:'#8b5cf6', fontWeight:'bold', fontSize:'0.78rem', cursor:'pointer', whiteSpace:'nowrap' }}>
                     Matchmaking Retos
                  </button>
                  <button onClick={async () => {
                    const { data, error } = await supabase.rpc('asignar_guerras_automaticas', { p_jornada: jornadaTorneo });
                    alert(error ? 'Error: ' + error.message : '✓ ' + data);
                  }}
                    style={{ padding:'9px 20px', background:'#8b5cf622', border:'1px solid #8b5cf6', borderRadius:'7px', color:'#8b5cf6', fontWeight:'bold', fontSize:'0.85rem', cursor:'pointer', whiteSpace:'nowrap' }}>
                    Desafío 5v5
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* PASO 2 — CERRAR FECHA */}
          <div>
            <p style={{ color:'#334155', fontSize:'0.68rem', fontWeight:'bold', textTransform:'uppercase', letterSpacing:'2px', margin:'0 0 6px 2px' }}>— PASO 2 · Cuando terminaste de cargar TODOS los jugadores</p>
            <div style={{ background:'#080d14', border:'1px solid #ef444433', borderRadius:'10px', padding:'14px 18px' }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'8px' }}>
                <div>
                  <span style={{ color:'#ef4444', fontSize:'0.75rem', fontWeight:'bold', textTransform:'uppercase', letterSpacing:'1px' }}>Cerrar Fecha {jornadaTorneo}</span>
                  <p style={{ color:'#475569', fontSize:'0.68rem', margin:'3px 0 0' }}>Desactiva la ventana de transferencias, cierra las fechas del torneo y activa la siguiente. Irreversible.</p>
                </div>
                <button onClick={cerrarFecha} disabled={cerrandoFecha}
                  style={{ flexShrink:0, padding:'9px 20px', background: cerrandoFecha ? '#0a0f19' : '#ef444422', border:`1px solid ${cerrandoFecha?'#1e293b':'#ef4444'}`, borderRadius:'7px', color: cerrandoFecha ? '#475569' : '#ef4444', fontWeight:'bold', fontSize:'0.85rem', cursor: cerrandoFecha ? 'default' : 'pointer', transition:'0.2s', whiteSpace:'nowrap' }}>
                  {cerrandoFecha ? ' Cerrando...' : 'Cerrar Fecha'}
                </button>
              </div>
              {cierreLog && (
                <div style={{ padding:'6px 12px', background: cierreLog.ok ? '#22c55e10' : '#ef444410', border:`1px solid ${cierreLog.ok ? '#22c55e33' : '#ef444433'}`, borderRadius:'7px', color: cierreLog.ok ? '#22c55e' : '#ef4444', fontSize:'0.78rem' }}>
                  {cierreLog.msg}
                </div>
              )}
            </div>
            {/* Botón separado: abrir ventana siguiente sin cerrar la actual */}
            <div style={{ marginTop:'10px', display:'flex', alignItems:'center', justifyContent:'space-between', padding:'10px 14px', background:'#080d14', border:'1px solid #1e293b', borderRadius:'8px' }}>
              <div>
                <span style={{ color:'#94a3b8', fontSize:'0.75rem', fontWeight:'bold' }}>Abrir ventana Fecha {jornadaTorneo + 1}</span>
                <p style={{ color:'#475569', fontSize:'0.68rem', margin:'2px 0 0' }}>Permite armar equipos de j{jornadaTorneo + 1} sin cerrar j{jornadaTorneo}. Útil cuando los partidos se solapan.</p>
              </div>
              <button onClick={abrirVentanaSiguiente} disabled={abriendoVentana}
                style={{ flexShrink:0, padding:'7px 14px', background:'#1e293b', border:'1px solid #334155', borderRadius:'7px', color:'#94a3b8', fontWeight:'bold', fontSize:'0.8rem', cursor:'pointer' }}>
                {abriendoVentana ? '...' : 'Abrir'}
              </button>
            </div>
          </div>

          {/* PASO 3 */}
          <div>
            <p style={{ color:'#334155', fontSize:'0.68rem', fontWeight:'bold', textTransform:'uppercase', letterSpacing:'2px', margin:'0 0 6px 2px' }}>— PASO 3 · Después de cerrar la fecha</p>
            <div style={{ background:'#080d14', border:'1px solid #f59e0b33', borderRadius:'10px', padding:'14px 18px' }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'8px' }}>
                <div>
                  <span style={{ color:'#f59e0b', fontSize:'0.75rem', fontWeight:'bold', textTransform:'uppercase', letterSpacing:'1px' }}>Distribuir puntos a torneos</span>
                  <p style={{ color:'#475569', fontSize:'0.68rem', margin:'3px 0 0' }}>Calcula puntos de cada equipo, distribuye medallas de fecha, resuelve guerras y detecta jugadas preparadas</p>
                </div>
                <button onClick={distribuirPuntos} disabled={distribuyendo}
                  style={{ flexShrink:0, padding:'9px 20px', background: distribuyendo ? '#0a0f19' : '#f59e0b22', border:`1px solid ${distribuyendo?'#1e293b':'#f59e0b'}`, borderRadius:'7px', color: distribuyendo ? '#475569' : '#f59e0b', fontWeight:'bold', fontSize:'0.85rem', cursor: distribuyendo ? 'default' : 'pointer', transition:'0.2s', whiteSpace:'nowrap' }}>
                  {distribuyendo ? 'Distribuyendo...' : 'Ejecutar'}
                </button>
              </div>
              {distribucionLog && (
                <div style={{ padding:'6px 12px', background: distribucionLog.ok ? '#22c55e10' : '#ef444410', border:`1px solid ${distribucionLog.ok ? '#22c55e33' : '#ef444433'}`, borderRadius:'7px', color: distribucionLog.ok ? '#22c55e' : '#ef4444', fontSize:'0.78rem' }}>
                  {distribucionLog.msg}
                </div>
              )}
              {/* Botón solo libre */}
              <div style={{ marginTop:'10px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <span style={{ color:'#3b82f6', fontSize:'0.72rem', fontWeight:'bold' }}>Solo equipo libre</span>
                <button onClick={distribuirPuntosLibre} disabled={distribuyendoLibre}
                  style={{ padding:'7px 16px', background: distribuyendoLibre ? '#0a0f19' : '#3b82f622', border:`1px solid ${distribuyendoLibre?'#1e293b':'#3b82f6'}`, borderRadius:'7px', color: distribuyendoLibre ? '#475569' : '#3b82f6', fontWeight:'bold', fontSize:'0.8rem', cursor: distribuyendoLibre ? 'default' : 'pointer' }}>
                  {distribuyendoLibre ? 'Distribuyendo...' : 'Distribuir Libre'}
                </button>
              </div>
            </div>
          </div>

          {/* PASO 3 */}
          <div>
            <p style={{ color:'#334155', fontSize:'0.68rem', fontWeight:'bold', textTransform:'uppercase', letterSpacing:'2px', margin:'0 0 6px 2px' }}>— PASO 4</p>
            <div style={{ background:'#080d14', border:'1px solid #a855f733', borderRadius:'10px', padding:'14px 18px' }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'8px' }}>
                <div>
                  <span style={{ color:'#a855f7', fontSize:'0.75rem', fontWeight:'bold', textTransform:'uppercase', letterSpacing:'1px' }}> Calcular puntos del Prode</span>
                  <p style={{ color:'#475569', fontSize:'0.68rem', margin:'3px 0 0' }}>Aplica a todos los partidos finalizados con resultado cargado</p>
                </div>
                <button onClick={calcularPuntosProde} disabled={calculandoProde}
                  style={{ flexShrink:0, padding:'9px 20px', background: calculandoProde ? '#0a0f19' : '#a855f722', border:`1px solid ${calculandoProde?'#1e293b':'#a855f7'}`, borderRadius:'7px', color: calculandoProde ? '#475569' : '#a855f7', fontWeight:'bold', fontSize:'0.85rem', cursor: calculandoProde ? 'default' : 'pointer', transition:'0.2s', whiteSpace:'nowrap' }}>
                  {calculandoProde ? ' Calculando...' : ' Ejecutar'}
                </button>
              </div>
              {prodeLog && (
                <div style={{ padding:'6px 12px', background: prodeLog.ok ? '#22c55e10' : '#ef444410', border:`1px solid ${prodeLog.ok?'#22c55e33':'#ef444433'}`, borderRadius:'7px', color: prodeLog.ok ? '#22c55e' : '#ef4444', fontSize:'0.78rem' }}>
                  {prodeLog.msg}
                </div>
              )}
            </div>
          </div>

          {/* PASO 4 */}
          <div>
            <p style={{ color:'#334155', fontSize:'0.68rem', fontWeight:'bold', textTransform:'uppercase', letterSpacing:'2px', margin:'0 0 6px 2px' }}>— PASO 5</p>
            <div style={{ background:'#080d14', border:'1px solid #a855f733', borderRadius:'10px', padding:'14px 18px' }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'8px' }}>
                <div>
                  <span style={{ color:'#a855f7', fontSize:'0.75rem', fontWeight:'bold', textTransform:'uppercase', letterSpacing:'1px' }}>Resolver Ranked 1v1</span>
                  <p style={{ color:'#475569', fontSize:'0.68rem', margin:'3px 0 0' }}>Jornada {jornadaTorneo} — compara puntos y actualiza victorias, rango e hitos</p>
                </div>
                <div style={{ display:'flex', gap:'8px', flexShrink:0 }}>
                  <button onClick={resolverRanked} disabled={resolviendoRanked}
                    style={{ padding:'9px 20px', background: resolviendoRanked ? '#0a0f19' : '#a855f722', border:`1px solid ${resolviendoRanked?'#1e293b':'#a855f7'}`, borderRadius:'7px', color: resolviendoRanked ? '#475569' : '#a855f7', fontWeight:'bold', fontSize:'0.85rem', cursor: resolviendoRanked ? 'default' : 'pointer', transition:'0.2s', whiteSpace:'nowrap' }}>
                    {resolviendoRanked ? 'Resolviendo...' : ' Ejecutar'}
                  </button>
                </div>
              </div>
              {rankedLog && (
                <div style={{ padding:'6px 12px', background: rankedLog.ok ? '#22c55e10' : '#ef444410', border:`1px solid ${rankedLog.ok ? '#22c55e33' : '#ef444433'}`, borderRadius:'7px', color: rankedLog.ok ? '#22c55e' : '#ef4444', fontSize:'0.78rem' }}>
                  {rankedLog.msg}
                </div>
              )}
            </div>
          </div>

          {/* PASO 5 */}
          <div>
            <p style={{ color:'#334155', fontSize:'0.68rem', fontWeight:'bold', textTransform:'uppercase', letterSpacing:'2px', margin:'0 0 6px 2px' }}>— PASO 6</p>
            <div style={{ background:'#080d14', border:'1px solid #f9731633', borderRadius:'10px', padding:'14px 18px' }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'8px' }}>
                <div>
                  <span style={{ color:'#f97316', fontSize:'0.75rem', fontWeight:'bold', textTransform:'uppercase', letterSpacing:'1px' }}> Resolver desafíos & Retos de Club</span>
                  <p style={{ color:'#475569', fontSize:'0.68rem', margin:'3px 0 0' }}>Jornada {jornadaTorneo} — resuelve guerras y retos usando los puntos ya distribuidos. Ejecutar después del Paso 2.</p>
                </div>
                <button onClick={resolverGuerrasManuales} disabled={resolviendoGuerras}
                  style={{ flexShrink:0, padding:'9px 20px', background: resolviendoGuerras ? '#0a0f19' : '#f9731622', border:`1px solid ${resolviendoGuerras?'#1e293b':'#f97316'}`, borderRadius:'7px', color: resolviendoGuerras ? '#475569' : '#f97316', fontWeight:'bold', fontSize:'0.85rem', cursor: resolviendoGuerras ? 'default' : 'pointer', transition:'0.2s', whiteSpace:'nowrap' }}>
                  {resolviendoGuerras ? ' Resolviendo...' : ' Ejecutar'}
                </button>
              </div>
              {guerrasLog && (
                <div style={{ padding:'6px 12px', background: guerrasLog.ok ? '#22c55e10' : '#ef444410', border:`1px solid ${guerrasLog.ok ? '#22c55e33' : '#ef444433'}`, borderRadius:'7px', color: guerrasLog.ok ? '#22c55e' : '#ef4444', fontSize:'0.78rem' }}>
                  {guerrasLog.msg}
                </div>
              )}
            </div>
          </div>

        </div>
      )}
    </div>
  );
};export default AdminPuntos;